var cov_2ferdkoho4 = function () {
  var path = "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/portfolio/portfolioCtrl.js",
      hash = "3af034fe2a5f84d75291853fa50dc72295d64e7f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/portfolio/portfolioCtrl.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 691,
          column: 3
        }
      },
      "1": {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 23
        }
      },
      "2": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 7,
          column: 5
        }
      },
      "3": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 49
        }
      },
      "4": {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 37
        }
      },
      "5": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 28
        }
      },
      "6": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "7": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 45
        }
      },
      "8": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 48
        }
      },
      "9": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 34
        }
      },
      "10": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 587,
          column: 4
        }
      },
      "11": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 75
        }
      },
      "12": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 41
        }
      },
      "13": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 42,
          column: 7
        }
      },
      "14": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 41,
          column: 9
        }
      },
      "15": {
        start: {
          line: 40,
          column: 10
        },
        end: {
          line: 40,
          column: 23
        }
      },
      "16": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 18
        }
      },
      "17": {
        start: {
          line: 291,
          column: 6
        },
        end: {
          line: 291,
          column: 46
        }
      },
      "18": {
        start: {
          line: 294,
          column: 6
        },
        end: {
          line: 296,
          column: 7
        }
      },
      "19": {
        start: {
          line: 295,
          column: 8
        },
        end: {
          line: 295,
          column: 15
        }
      },
      "20": {
        start: {
          line: 297,
          column: 6
        },
        end: {
          line: 297,
          column: 56
        }
      },
      "21": {
        start: {
          line: 300,
          column: 6
        },
        end: {
          line: 300,
          column: 39
        }
      },
      "22": {
        start: {
          line: 302,
          column: 6
        },
        end: {
          line: 302,
          column: 36
        }
      },
      "23": {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 305,
          column: 7
        }
      },
      "24": {
        start: {
          line: 304,
          column: 8
        },
        end: {
          line: 304,
          column: 15
        }
      },
      "25": {
        start: {
          line: 306,
          column: 6
        },
        end: {
          line: 306,
          column: 49
        }
      },
      "26": {
        start: {
          line: 307,
          column: 6
        },
        end: {
          line: 307,
          column: 61
        }
      },
      "27": {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 308,
          column: 42
        }
      },
      "28": {
        start: {
          line: 310,
          column: 6
        },
        end: {
          line: 310,
          column: 34
        }
      },
      "29": {
        start: {
          line: 313,
          column: 6
        },
        end: {
          line: 329,
          column: 9
        }
      },
      "30": {
        start: {
          line: 314,
          column: 8
        },
        end: {
          line: 314,
          column: 47
        }
      },
      "31": {
        start: {
          line: 315,
          column: 8
        },
        end: {
          line: 328,
          column: 9
        }
      },
      "32": {
        start: {
          line: 316,
          column: 10
        },
        end: {
          line: 322,
          column: 11
        }
      },
      "33": {
        start: {
          line: 317,
          column: 12
        },
        end: {
          line: 317,
          column: 52
        }
      },
      "34": {
        start: {
          line: 318,
          column: 12
        },
        end: {
          line: 318,
          column: 52
        }
      },
      "35": {
        start: {
          line: 319,
          column: 12
        },
        end: {
          line: 319,
          column: 52
        }
      },
      "36": {
        start: {
          line: 320,
          column: 12
        },
        end: {
          line: 320,
          column: 52
        }
      },
      "37": {
        start: {
          line: 321,
          column: 12
        },
        end: {
          line: 321,
          column: 52
        }
      },
      "38": {
        start: {
          line: 323,
          column: 10
        },
        end: {
          line: 327,
          column: 11
        }
      },
      "39": {
        start: {
          line: 324,
          column: 12
        },
        end: {
          line: 324,
          column: 55
        }
      },
      "40": {
        start: {
          line: 326,
          column: 12
        },
        end: {
          line: 326,
          column: 72
        }
      },
      "41": {
        start: {
          line: 332,
          column: 19
        },
        end: {
          line: 332,
          column: 42
        }
      },
      "42": {
        start: {
          line: 333,
          column: 22
        },
        end: {
          line: 333,
          column: 24
        }
      },
      "43": {
        start: {
          line: 334,
          column: 6
        },
        end: {
          line: 360,
          column: 7
        }
      },
      "44": {
        start: {
          line: 335,
          column: 8
        },
        end: {
          line: 338,
          column: 11
        }
      },
      "45": {
        start: {
          line: 337,
          column: 10
        },
        end: {
          line: 337,
          column: 85
        }
      },
      "46": {
        start: {
          line: 340,
          column: 8
        },
        end: {
          line: 342,
          column: 11
        }
      },
      "47": {
        start: {
          line: 341,
          column: 10
        },
        end: {
          line: 341,
          column: 44
        }
      },
      "48": {
        start: {
          line: 344,
          column: 8
        },
        end: {
          line: 355,
          column: 11
        }
      },
      "49": {
        start: {
          line: 345,
          column: 25
        },
        end: {
          line: 345,
          column: 53
        }
      },
      "50": {
        start: {
          line: 347,
          column: 10
        },
        end: {
          line: 352,
          column: 11
        }
      },
      "51": {
        start: {
          line: 348,
          column: 12
        },
        end: {
          line: 348,
          column: 72
        }
      },
      "52": {
        start: {
          line: 349,
          column: 12
        },
        end: {
          line: 349,
          column: 35
        }
      },
      "53": {
        start: {
          line: 351,
          column: 12
        },
        end: {
          line: 351,
          column: 54
        }
      },
      "54": {
        start: {
          line: 354,
          column: 10
        },
        end: {
          line: 354,
          column: 70
        }
      },
      "55": {
        start: {
          line: 362,
          column: 6
        },
        end: {
          line: 362,
          column: 18
        }
      },
      "56": {
        start: {
          line: 366,
          column: 6
        },
        end: {
          line: 373,
          column: 7
        }
      },
      "57": {
        start: {
          line: 367,
          column: 8
        },
        end: {
          line: 371,
          column: 11
        }
      },
      "58": {
        start: {
          line: 372,
          column: 8
        },
        end: {
          line: 372,
          column: 15
        }
      },
      "59": {
        start: {
          line: 374,
          column: 19
        },
        end: {
          line: 374,
          column: 33
        }
      },
      "60": {
        start: {
          line: 375,
          column: 6
        },
        end: {
          line: 375,
          column: 43
        }
      },
      "61": {
        start: {
          line: 376,
          column: 6
        },
        end: {
          line: 434,
          column: 9
        }
      },
      "62": {
        start: {
          line: 438,
          column: 6
        },
        end: {
          line: 438,
          column: 45
        }
      },
      "63": {
        start: {
          line: 439,
          column: 6
        },
        end: {
          line: 439,
          column: 62
        }
      },
      "64": {
        start: {
          line: 440,
          column: 6
        },
        end: {
          line: 440,
          column: 59
        }
      },
      "65": {
        start: {
          line: 441,
          column: 6
        },
        end: {
          line: 441,
          column: 59
        }
      },
      "66": {
        start: {
          line: 442,
          column: 6
        },
        end: {
          line: 442,
          column: 66
        }
      },
      "67": {
        start: {
          line: 443,
          column: 6
        },
        end: {
          line: 443,
          column: 49
        }
      },
      "68": {
        start: {
          line: 445,
          column: 6
        },
        end: {
          line: 447,
          column: 21
        }
      },
      "69": {
        start: {
          line: 446,
          column: 15
        },
        end: {
          line: 446,
          column: 39
        }
      },
      "70": {
        start: {
          line: 450,
          column: 6
        },
        end: {
          line: 453,
          column: 9
        }
      },
      "71": {
        start: {
          line: 451,
          column: 8
        },
        end: {
          line: 451,
          column: 49
        }
      },
      "72": {
        start: {
          line: 452,
          column: 8
        },
        end: {
          line: 452,
          column: 37
        }
      },
      "73": {
        start: {
          line: 455,
          column: 6
        },
        end: {
          line: 457,
          column: 9
        }
      },
      "74": {
        start: {
          line: 456,
          column: 8
        },
        end: {
          line: 456,
          column: 37
        }
      },
      "75": {
        start: {
          line: 459,
          column: 6
        },
        end: {
          line: 466,
          column: 9
        }
      },
      "76": {
        start: {
          line: 471,
          column: 6
        },
        end: {
          line: 471,
          column: 26
        }
      },
      "77": {
        start: {
          line: 473,
          column: 8
        },
        end: {
          line: 473,
          column: 65
        }
      },
      "78": {
        start: {
          line: 475,
          column: 6
        },
        end: {
          line: 532,
          column: 9
        }
      },
      "79": {
        start: {
          line: 478,
          column: 21
        },
        end: {
          line: 478,
          column: 42
        }
      },
      "80": {
        start: {
          line: 507,
          column: 8
        },
        end: {
          line: 516,
          column: 11
        }
      },
      "81": {
        start: {
          line: 508,
          column: 10
        },
        end: {
          line: 511,
          column: 12
        }
      },
      "82": {
        start: {
          line: 512,
          column: 10
        },
        end: {
          line: 512,
          column: 74
        }
      },
      "83": {
        start: {
          line: 513,
          column: 10
        },
        end: {
          line: 513,
          column: 74
        }
      },
      "84": {
        start: {
          line: 514,
          column: 10
        },
        end: {
          line: 514,
          column: 66
        }
      },
      "85": {
        start: {
          line: 515,
          column: 10
        },
        end: {
          line: 515,
          column: 25
        }
      },
      "86": {
        start: {
          line: 521,
          column: 32
        },
        end: {
          line: 523,
          column: 10
        }
      },
      "87": {
        start: {
          line: 522,
          column: 10
        },
        end: {
          line: 522,
          column: 33
        }
      },
      "88": {
        start: {
          line: 524,
          column: 8
        },
        end: {
          line: 524,
          column: 37
        }
      },
      "89": {
        start: {
          line: 525,
          column: 26
        },
        end: {
          line: 525,
          column: 162
        }
      },
      "90": {
        start: {
          line: 526,
          column: 8
        },
        end: {
          line: 530,
          column: 9
        }
      },
      "91": {
        start: {
          line: 527,
          column: 10
        },
        end: {
          line: 527,
          column: 57
        }
      },
      "92": {
        start: {
          line: 528,
          column: 10
        },
        end: {
          line: 528,
          column: 60
        }
      },
      "93": {
        start: {
          line: 529,
          column: 10
        },
        end: {
          line: 529,
          column: 17
        }
      },
      "94": {
        start: {
          line: 531,
          column: 8
        },
        end: {
          line: 531,
          column: 29
        }
      },
      "95": {
        start: {
          line: 535,
          column: 6
        },
        end: {
          line: 541,
          column: 8
        }
      },
      "96": {
        start: {
          line: 539,
          column: 10
        },
        end: {
          line: 539,
          column: 31
        }
      },
      "97": {
        start: {
          line: 545,
          column: 6
        },
        end: {
          line: 577,
          column: 8
        }
      },
      "98": {
        start: {
          line: 557,
          column: 10
        },
        end: {
          line: 559,
          column: 11
        }
      },
      "99": {
        start: {
          line: 558,
          column: 12
        },
        end: {
          line: 558,
          column: 19
        }
      },
      "100": {
        start: {
          line: 560,
          column: 10
        },
        end: {
          line: 560,
          column: 34
        }
      },
      "101": {
        start: {
          line: 561,
          column: 10
        },
        end: {
          line: 575,
          column: 12
        }
      },
      "102": {
        start: {
          line: 565,
          column: 14
        },
        end: {
          line: 572,
          column: 15
        }
      },
      "103": {
        start: {
          line: 566,
          column: 16
        },
        end: {
          line: 569,
          column: 19
        }
      },
      "104": {
        start: {
          line: 570,
          column: 16
        },
        end: {
          line: 570,
          column: 41
        }
      },
      "105": {
        start: {
          line: 571,
          column: 16
        },
        end: {
          line: 571,
          column: 23
        }
      },
      "106": {
        start: {
          line: 573,
          column: 14
        },
        end: {
          line: 573,
          column: 35
        }
      },
      "107": {
        start: {
          line: 580,
          column: 6
        },
        end: {
          line: 580,
          column: 31
        }
      },
      "108": {
        start: {
          line: 581,
          column: 6
        },
        end: {
          line: 581,
          column: 27
        }
      },
      "109": {
        start: {
          line: 584,
          column: 6
        },
        end: {
          line: 584,
          column: 26
        }
      },
      "110": {
        start: {
          line: 585,
          column: 6
        },
        end: {
          line: 585,
          column: 39
        }
      },
      "111": {
        start: {
          line: 589,
          column: 20
        },
        end: {
          line: 599,
          column: 4
        }
      },
      "112": {
        start: {
          line: 601,
          column: 2
        },
        end: {
          line: 606,
          column: 4
        }
      },
      "113": {
        start: {
          line: 602,
          column: 4
        },
        end: {
          line: 603,
          column: 68
        }
      },
      "114": {
        start: {
          line: 604,
          column: 4
        },
        end: {
          line: 604,
          column: 28
        }
      },
      "115": {
        start: {
          line: 605,
          column: 4
        },
        end: {
          line: 605,
          column: 22
        }
      },
      "116": {
        start: {
          line: 608,
          column: 2
        },
        end: {
          line: 621,
          column: 4
        }
      },
      "117": {
        start: {
          line: 609,
          column: 4
        },
        end: {
          line: 609,
          column: 41
        }
      },
      "118": {
        start: {
          line: 610,
          column: 4
        },
        end: {
          line: 618,
          column: 5
        }
      },
      "119": {
        start: {
          line: 611,
          column: 6
        },
        end: {
          line: 617,
          column: 7
        }
      },
      "120": {
        start: {
          line: 612,
          column: 8
        },
        end: {
          line: 615,
          column: 10
        }
      },
      "121": {
        start: {
          line: 616,
          column: 8
        },
        end: {
          line: 616,
          column: 14
        }
      },
      "122": {
        start: {
          line: 619,
          column: 4
        },
        end: {
          line: 619,
          column: 46
        }
      },
      "123": {
        start: {
          line: 620,
          column: 4
        },
        end: {
          line: 620,
          column: 29
        }
      },
      "124": {
        start: {
          line: 624,
          column: 2
        },
        end: {
          line: 640,
          column: 5
        }
      },
      "125": {
        start: {
          line: 625,
          column: 4
        },
        end: {
          line: 625,
          column: 56
        }
      },
      "126": {
        start: {
          line: 626,
          column: 4
        },
        end: {
          line: 631,
          column: 5
        }
      },
      "127": {
        start: {
          line: 627,
          column: 6
        },
        end: {
          line: 629,
          column: 9
        }
      },
      "128": {
        start: {
          line: 628,
          column: 8
        },
        end: {
          line: 628,
          column: 42
        }
      },
      "129": {
        start: {
          line: 630,
          column: 6
        },
        end: {
          line: 630,
          column: 13
        }
      },
      "130": {
        start: {
          line: 632,
          column: 4
        },
        end: {
          line: 638,
          column: 5
        }
      },
      "131": {
        start: {
          line: 633,
          column: 6
        },
        end: {
          line: 637,
          column: 7
        }
      },
      "132": {
        start: {
          line: 634,
          column: 8
        },
        end: {
          line: 634,
          column: 38
        }
      },
      "133": {
        start: {
          line: 635,
          column: 8
        },
        end: {
          line: 635,
          column: 40
        }
      },
      "134": {
        start: {
          line: 636,
          column: 8
        },
        end: {
          line: 636,
          column: 15
        }
      },
      "135": {
        start: {
          line: 639,
          column: 4
        },
        end: {
          line: 639,
          column: 37
        }
      },
      "136": {
        start: {
          line: 642,
          column: 2
        },
        end: {
          line: 658,
          column: 5
        }
      },
      "137": {
        start: {
          line: 643,
          column: 4
        },
        end: {
          line: 643,
          column: 56
        }
      },
      "138": {
        start: {
          line: 644,
          column: 4
        },
        end: {
          line: 649,
          column: 5
        }
      },
      "139": {
        start: {
          line: 645,
          column: 6
        },
        end: {
          line: 647,
          column: 9
        }
      },
      "140": {
        start: {
          line: 646,
          column: 8
        },
        end: {
          line: 646,
          column: 42
        }
      },
      "141": {
        start: {
          line: 648,
          column: 6
        },
        end: {
          line: 648,
          column: 13
        }
      },
      "142": {
        start: {
          line: 650,
          column: 4
        },
        end: {
          line: 656,
          column: 5
        }
      },
      "143": {
        start: {
          line: 651,
          column: 6
        },
        end: {
          line: 655,
          column: 7
        }
      },
      "144": {
        start: {
          line: 652,
          column: 8
        },
        end: {
          line: 652,
          column: 38
        }
      },
      "145": {
        start: {
          line: 653,
          column: 8
        },
        end: {
          line: 653,
          column: 40
        }
      },
      "146": {
        start: {
          line: 654,
          column: 8
        },
        end: {
          line: 654,
          column: 15
        }
      },
      "147": {
        start: {
          line: 657,
          column: 4
        },
        end: {
          line: 657,
          column: 37
        }
      },
      "148": {
        start: {
          line: 661,
          column: 2
        },
        end: {
          line: 670,
          column: 4
        }
      },
      "149": {
        start: {
          line: 662,
          column: 4
        },
        end: {
          line: 669,
          column: 7
        }
      },
      "150": {
        start: {
          line: 672,
          column: 2
        },
        end: {
          line: 681,
          column: 4
        }
      },
      "151": {
        start: {
          line: 673,
          column: 4
        },
        end: {
          line: 680,
          column: 7
        }
      },
      "152": {
        start: {
          line: 684,
          column: 2
        },
        end: {
          line: 688,
          column: 5
        }
      },
      "153": {
        start: {
          line: 685,
          column: 4
        },
        end: {
          line: 687,
          column: 5
        }
      },
      "154": {
        start: {
          line: 686,
          column: 6
        },
        end: {
          line: 686,
          column: 63
        }
      },
      "155": {
        start: {
          line: 690,
          column: 2
        },
        end: {
          line: 690,
          column: 23
        }
      },
      "156": {
        start: {
          line: 694,
          column: 15
        },
        end: {
          line: 694,
          column: 23
        }
      },
      "157": {
        start: {
          line: 696,
          column: 2
        },
        end: {
          line: 696,
          column: 41
        }
      },
      "158": {
        start: {
          line: 697,
          column: 2
        },
        end: {
          line: 709,
          column: 5
        }
      },
      "159": {
        start: {
          line: 698,
          column: 4
        },
        end: {
          line: 708,
          column: 6
        }
      },
      "160": {
        start: {
          line: 706,
          column: 8
        },
        end: {
          line: 706,
          column: 20
        }
      },
      "161": {
        start: {
          line: 711,
          column: 2
        },
        end: {
          line: 711,
          column: 24
        }
      },
      "162": {
        start: {
          line: 713,
          column: 2
        },
        end: {
          line: 735,
          column: 4
        }
      },
      "163": {
        start: {
          line: 719,
          column: 6
        },
        end: {
          line: 724,
          column: 7
        }
      },
      "164": {
        start: {
          line: 720,
          column: 8
        },
        end: {
          line: 720,
          column: 54
        }
      },
      "165": {
        start: {
          line: 721,
          column: 8
        },
        end: {
          line: 721,
          column: 50
        }
      },
      "166": {
        start: {
          line: 722,
          column: 8
        },
        end: {
          line: 722,
          column: 77
        }
      },
      "167": {
        start: {
          line: 723,
          column: 8
        },
        end: {
          line: 723,
          column: 73
        }
      },
      "168": {
        start: {
          line: 726,
          column: 6
        },
        end: {
          line: 731,
          column: 7
        }
      },
      "169": {
        start: {
          line: 727,
          column: 8
        },
        end: {
          line: 727,
          column: 54
        }
      },
      "170": {
        start: {
          line: 728,
          column: 8
        },
        end: {
          line: 728,
          column: 50
        }
      },
      "171": {
        start: {
          line: 729,
          column: 8
        },
        end: {
          line: 729,
          column: 77
        }
      },
      "172": {
        start: {
          line: 730,
          column: 8
        },
        end: {
          line: 730,
          column: 73
        }
      },
      "173": {
        start: {
          line: 733,
          column: 6
        },
        end: {
          line: 733,
          column: 30
        }
      },
      "174": {
        start: {
          line: 737,
          column: 2
        },
        end: {
          line: 805,
          column: 4
        }
      },
      "175": {
        start: {
          line: 738,
          column: 4
        },
        end: {
          line: 738,
          column: 37
        }
      },
      "176": {
        start: {
          line: 739,
          column: 17
        },
        end: {
          line: 739,
          column: 55
        }
      },
      "177": {
        start: {
          line: 741,
          column: 4
        },
        end: {
          line: 741,
          column: 66
        }
      },
      "178": {
        start: {
          line: 742,
          column: 18
        },
        end: {
          line: 744,
          column: 6
        }
      },
      "179": {
        start: {
          line: 743,
          column: 6
        },
        end: {
          line: 743,
          column: 77
        }
      },
      "180": {
        start: {
          line: 746,
          column: 4
        },
        end: {
          line: 749,
          column: 5
        }
      },
      "181": {
        start: {
          line: 747,
          column: 6
        },
        end: {
          line: 747,
          column: 33
        }
      },
      "182": {
        start: {
          line: 748,
          column: 6
        },
        end: {
          line: 748,
          column: 13
        }
      },
      "183": {
        start: {
          line: 783,
          column: 4
        },
        end: {
          line: 786,
          column: 6
        }
      },
      "184": {
        start: {
          line: 787,
          column: 4
        },
        end: {
          line: 790,
          column: 6
        }
      },
      "185": {
        start: {
          line: 791,
          column: 4
        },
        end: {
          line: 791,
          column: 67
        }
      },
      "186": {
        start: {
          line: 792,
          column: 4
        },
        end: {
          line: 792,
          column: 43
        }
      },
      "187": {
        start: {
          line: 793,
          column: 4
        },
        end: {
          line: 793,
          column: 60
        }
      },
      "188": {
        start: {
          line: 794,
          column: 4
        },
        end: {
          line: 794,
          column: 64
        }
      },
      "189": {
        start: {
          line: 795,
          column: 4
        },
        end: {
          line: 795,
          column: 64
        }
      },
      "190": {
        start: {
          line: 796,
          column: 4
        },
        end: {
          line: 796,
          column: 64
        }
      },
      "191": {
        start: {
          line: 797,
          column: 4
        },
        end: {
          line: 804,
          column: 6
        }
      },
      "192": {
        start: {
          line: 801,
          column: 8
        },
        end: {
          line: 801,
          column: 29
        }
      },
      "193": {
        start: {
          line: 802,
          column: 8
        },
        end: {
          line: 802,
          column: 28
        }
      },
      "194": {
        start: {
          line: 806,
          column: 2
        },
        end: {
          line: 808,
          column: 4
        }
      },
      "195": {
        start: {
          line: 807,
          column: 4
        },
        end: {
          line: 807,
          column: 40
        }
      },
      "196": {
        start: {
          line: 812,
          column: 2
        },
        end: {
          line: 817,
          column: 4
        }
      },
      "197": {
        start: {
          line: 813,
          column: 4
        },
        end: {
          line: 816,
          column: 7
        }
      },
      "198": {
        start: {
          line: 819,
          column: 2
        },
        end: {
          line: 822,
          column: 4
        }
      },
      "199": {
        start: {
          line: 820,
          column: 4
        },
        end: {
          line: 820,
          column: 28
        }
      },
      "200": {
        start: {
          line: 821,
          column: 4
        },
        end: {
          line: 821,
          column: 49
        }
      },
      "201": {
        start: {
          line: 824,
          column: 2
        },
        end: {
          line: 826,
          column: 5
        }
      },
      "202": {
        start: {
          line: 825,
          column: 4
        },
        end: {
          line: 825,
          column: 35
        }
      },
      "203": {
        start: {
          line: 828,
          column: 2
        },
        end: {
          line: 861,
          column: 4
        }
      },
      "204": {
        start: {
          line: 829,
          column: 4
        },
        end: {
          line: 829,
          column: 27
        }
      },
      "205": {
        start: {
          line: 830,
          column: 4
        },
        end: {
          line: 830,
          column: 31
        }
      },
      "206": {
        start: {
          line: 832,
          column: 4
        },
        end: {
          line: 836,
          column: 5
        }
      },
      "207": {
        start: {
          line: 833,
          column: 6
        },
        end: {
          line: 833,
          column: 90
        }
      },
      "208": {
        start: {
          line: 835,
          column: 6
        },
        end: {
          line: 835,
          column: 33
        }
      },
      "209": {
        start: {
          line: 839,
          column: 4
        },
        end: {
          line: 842,
          column: 5
        }
      },
      "210": {
        start: {
          line: 840,
          column: 6
        },
        end: {
          line: 840,
          column: 36
        }
      },
      "211": {
        start: {
          line: 841,
          column: 6
        },
        end: {
          line: 841,
          column: 13
        }
      },
      "212": {
        start: {
          line: 845,
          column: 4
        },
        end: {
          line: 851,
          column: 5
        }
      },
      "213": {
        start: {
          line: 846,
          column: 8
        },
        end: {
          line: 847,
          column: 60
        }
      },
      "214": {
        start: {
          line: 849,
          column: 8
        },
        end: {
          line: 849,
          column: 38
        }
      },
      "215": {
        start: {
          line: 850,
          column: 8
        },
        end: {
          line: 850,
          column: 15
        }
      },
      "216": {
        start: {
          line: 853,
          column: 4
        },
        end: {
          line: 860,
          column: 7
        }
      },
      "217": {
        start: {
          line: 857,
          column: 8
        },
        end: {
          line: 857,
          column: 64
        }
      },
      "218": {
        start: {
          line: 858,
          column: 8
        },
        end: {
          line: 858,
          column: 69
        }
      },
      "219": {
        start: {
          line: 859,
          column: 8
        },
        end: {
          line: 859,
          column: 39
        }
      },
      "220": {
        start: {
          line: 863,
          column: 2
        },
        end: {
          line: 895,
          column: 5
        }
      },
      "221": {
        start: {
          line: 864,
          column: 4
        },
        end: {
          line: 894,
          column: 7
        }
      },
      "222": {
        start: {
          line: 876,
          column: 6
        },
        end: {
          line: 878,
          column: 7
        }
      },
      "223": {
        start: {
          line: 877,
          column: 8
        },
        end: {
          line: 877,
          column: 15
        }
      },
      "224": {
        start: {
          line: 879,
          column: 6
        },
        end: {
          line: 879,
          column: 30
        }
      },
      "225": {
        start: {
          line: 880,
          column: 27
        },
        end: {
          line: 882,
          column: 7
        }
      },
      "226": {
        start: {
          line: 883,
          column: 6
        },
        end: {
          line: 893,
          column: 9
        }
      },
      "227": {
        start: {
          line: 884,
          column: 8
        },
        end: {
          line: 891,
          column: 9
        }
      },
      "228": {
        start: {
          line: 885,
          column: 10
        },
        end: {
          line: 888,
          column: 13
        }
      },
      "229": {
        start: {
          line: 889,
          column: 10
        },
        end: {
          line: 889,
          column: 35
        }
      },
      "230": {
        start: {
          line: 890,
          column: 10
        },
        end: {
          line: 890,
          column: 17
        }
      },
      "231": {
        start: {
          line: 892,
          column: 8
        },
        end: {
          line: 892,
          column: 59
        }
      },
      "232": {
        start: {
          line: 897,
          column: 2
        },
        end: {
          line: 899,
          column: 4
        }
      },
      "233": {
        start: {
          line: 898,
          column: 4
        },
        end: {
          line: 898,
          column: 40
        }
      },
      "234": {
        start: {
          line: 903,
          column: 2
        },
        end: {
          line: 908,
          column: 4
        }
      },
      "235": {
        start: {
          line: 904,
          column: 4
        },
        end: {
          line: 907,
          column: 7
        }
      },
      "236": {
        start: {
          line: 910,
          column: 2
        },
        end: {
          line: 913,
          column: 4
        }
      },
      "237": {
        start: {
          line: 911,
          column: 4
        },
        end: {
          line: 911,
          column: 28
        }
      },
      "238": {
        start: {
          line: 912,
          column: 4
        },
        end: {
          line: 912,
          column: 49
        }
      },
      "239": {
        start: {
          line: 915,
          column: 2
        },
        end: {
          line: 917,
          column: 5
        }
      },
      "240": {
        start: {
          line: 916,
          column: 4
        },
        end: {
          line: 916,
          column: 35
        }
      },
      "241": {
        start: {
          line: 939,
          column: 2
        },
        end: {
          line: 972,
          column: 4
        }
      },
      "242": {
        start: {
          line: 940,
          column: 4
        },
        end: {
          line: 940,
          column: 27
        }
      },
      "243": {
        start: {
          line: 943,
          column: 4
        },
        end: {
          line: 947,
          column: 5
        }
      },
      "244": {
        start: {
          line: 944,
          column: 8
        },
        end: {
          line: 944,
          column: 92
        }
      },
      "245": {
        start: {
          line: 946,
          column: 8
        },
        end: {
          line: 946,
          column: 35
        }
      },
      "246": {
        start: {
          line: 950,
          column: 4
        },
        end: {
          line: 953,
          column: 5
        }
      },
      "247": {
        start: {
          line: 951,
          column: 8
        },
        end: {
          line: 951,
          column: 38
        }
      },
      "248": {
        start: {
          line: 952,
          column: 8
        },
        end: {
          line: 952,
          column: 15
        }
      },
      "249": {
        start: {
          line: 956,
          column: 4
        },
        end: {
          line: 962,
          column: 5
        }
      },
      "250": {
        start: {
          line: 957,
          column: 8
        },
        end: {
          line: 958,
          column: 60
        }
      },
      "251": {
        start: {
          line: 960,
          column: 8
        },
        end: {
          line: 960,
          column: 38
        }
      },
      "252": {
        start: {
          line: 961,
          column: 8
        },
        end: {
          line: 961,
          column: 15
        }
      },
      "253": {
        start: {
          line: 964,
          column: 4
        },
        end: {
          line: 971,
          column: 7
        }
      },
      "254": {
        start: {
          line: 968,
          column: 8
        },
        end: {
          line: 968,
          column: 64
        }
      },
      "255": {
        start: {
          line: 969,
          column: 8
        },
        end: {
          line: 969,
          column: 69
        }
      },
      "256": {
        start: {
          line: 970,
          column: 8
        },
        end: {
          line: 970,
          column: 39
        }
      },
      "257": {
        start: {
          line: 977,
          column: 2
        },
        end: {
          line: 1009,
          column: 5
        }
      },
      "258": {
        start: {
          line: 978,
          column: 4
        },
        end: {
          line: 1008,
          column: 7
        }
      },
      "259": {
        start: {
          line: 990,
          column: 6
        },
        end: {
          line: 992,
          column: 7
        }
      },
      "260": {
        start: {
          line: 991,
          column: 8
        },
        end: {
          line: 991,
          column: 15
        }
      },
      "261": {
        start: {
          line: 993,
          column: 6
        },
        end: {
          line: 993,
          column: 30
        }
      },
      "262": {
        start: {
          line: 994,
          column: 27
        },
        end: {
          line: 996,
          column: 7
        }
      },
      "263": {
        start: {
          line: 997,
          column: 6
        },
        end: {
          line: 1007,
          column: 9
        }
      },
      "264": {
        start: {
          line: 998,
          column: 8
        },
        end: {
          line: 1005,
          column: 9
        }
      },
      "265": {
        start: {
          line: 999,
          column: 10
        },
        end: {
          line: 1002,
          column: 13
        }
      },
      "266": {
        start: {
          line: 1003,
          column: 10
        },
        end: {
          line: 1003,
          column: 35
        }
      },
      "267": {
        start: {
          line: 1004,
          column: 10
        },
        end: {
          line: 1004,
          column: 17
        }
      },
      "268": {
        start: {
          line: 1006,
          column: 8
        },
        end: {
          line: 1006,
          column: 59
        }
      },
      "269": {
        start: {
          line: 1011,
          column: 2
        },
        end: {
          line: 1013,
          column: 4
        }
      },
      "270": {
        start: {
          line: 1012,
          column: 4
        },
        end: {
          line: 1012,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 49
          },
          end: {
            line: 1,
            column: 50
          }
        },
        loc: {
          start: {
            line: 1,
            column: 188
          },
          end: {
            line: 691,
            column: 1
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 4,
            column: 37
          },
          end: {
            line: 4,
            column: 38
          }
        },
        loc: {
          start: {
            line: 4,
            column: 43
          },
          end: {
            line: 7,
            column: 3
          }
        },
        line: 4
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 313,
            column: 66
          },
          end: {
            line: 313,
            column: 67
          }
        },
        loc: {
          start: {
            line: 313,
            column: 80
          },
          end: {
            line: 329,
            column: 7
          }
        },
        line: 313
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 335,
            column: 18
          },
          end: {
            line: 335,
            column: 19
          }
        },
        loc: {
          start: {
            line: 335,
            column: 37
          },
          end: {
            line: 338,
            column: 9
          }
        },
        line: 335
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 340,
            column: 21
          },
          end: {
            line: 340,
            column: 22
          }
        },
        loc: {
          start: {
            line: 340,
            column: 36
          },
          end: {
            line: 342,
            column: 9
          }
        },
        line: 340
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 344,
            column: 21
          },
          end: {
            line: 344,
            column: 22
          }
        },
        loc: {
          start: {
            line: 344,
            column: 36
          },
          end: {
            line: 355,
            column: 9
          }
        },
        line: 344
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 446,
            column: 8
          },
          end: {
            line: 446,
            column: 9
          }
        },
        loc: {
          start: {
            line: 446,
            column: 15
          },
          end: {
            line: 446,
            column: 39
          }
        },
        line: 446
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 450,
            column: 85
          },
          end: {
            line: 450,
            column: 86
          }
        },
        loc: {
          start: {
            line: 450,
            column: 93
          },
          end: {
            line: 453,
            column: 7
          }
        },
        line: 450
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 455,
            column: 85
          },
          end: {
            line: 455,
            column: 86
          }
        },
        loc: {
          start: {
            line: 455,
            column: 93
          },
          end: {
            line: 457,
            column: 7
          }
        },
        line: 455
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 475,
            column: 67
          },
          end: {
            line: 475,
            column: 68
          }
        },
        loc: {
          start: {
            line: 475,
            column: 78
          },
          end: {
            line: 532,
            column: 7
          }
        },
        line: 475
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 507,
            column: 35
          },
          end: {
            line: 507,
            column: 36
          }
        },
        loc: {
          start: {
            line: 507,
            column: 48
          },
          end: {
            line: 516,
            column: 9
          }
        },
        line: 507
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 521,
            column: 55
          },
          end: {
            line: 521,
            column: 56
          }
        },
        loc: {
          start: {
            line: 521,
            column: 65
          },
          end: {
            line: 523,
            column: 9
          }
        },
        line: 521
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 538,
            column: 8
          },
          end: {
            line: 538,
            column: 9
          }
        },
        loc: {
          start: {
            line: 538,
            column: 18
          },
          end: {
            line: 540,
            column: 9
          }
        },
        line: 538
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 556,
            column: 8
          },
          end: {
            line: 556,
            column: 9
          }
        },
        loc: {
          start: {
            line: 556,
            column: 23
          },
          end: {
            line: 576,
            column: 9
          }
        },
        line: 556
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 564,
            column: 12
          },
          end: {
            line: 564,
            column: 13
          }
        },
        loc: {
          start: {
            line: 564,
            column: 22
          },
          end: {
            line: 574,
            column: 13
          }
        },
        line: 564
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 601,
            column: 31
          },
          end: {
            line: 601,
            column: 32
          }
        },
        loc: {
          start: {
            line: 601,
            column: 66
          },
          end: {
            line: 606,
            column: 3
          }
        },
        line: 601
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 608,
            column: 27
          },
          end: {
            line: 608,
            column: 28
          }
        },
        loc: {
          start: {
            line: 608,
            column: 74
          },
          end: {
            line: 621,
            column: 3
          }
        },
        line: 608
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 624,
            column: 27
          },
          end: {
            line: 624,
            column: 28
          }
        },
        loc: {
          start: {
            line: 624,
            column: 49
          },
          end: {
            line: 640,
            column: 3
          }
        },
        line: 624
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 627,
            column: 59
          },
          end: {
            line: 627,
            column: 60
          }
        },
        loc: {
          start: {
            line: 627,
            column: 75
          },
          end: {
            line: 629,
            column: 7
          }
        },
        line: 627
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 642,
            column: 27
          },
          end: {
            line: 642,
            column: 28
          }
        },
        loc: {
          start: {
            line: 642,
            column: 49
          },
          end: {
            line: 658,
            column: 3
          }
        },
        line: 642
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 645,
            column: 59
          },
          end: {
            line: 645,
            column: 60
          }
        },
        loc: {
          start: {
            line: 645,
            column: 75
          },
          end: {
            line: 647,
            column: 7
          }
        },
        line: 645
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 661,
            column: 29
          },
          end: {
            line: 661,
            column: 30
          }
        },
        loc: {
          start: {
            line: 661,
            column: 41
          },
          end: {
            line: 670,
            column: 3
          }
        },
        line: 661
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 672,
            column: 29
          },
          end: {
            line: 672,
            column: 30
          }
        },
        loc: {
          start: {
            line: 672,
            column: 41
          },
          end: {
            line: 681,
            column: 3
          }
        },
        line: 672
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 684,
            column: 57
          },
          end: {
            line: 684,
            column: 58
          }
        },
        loc: {
          start: {
            line: 684,
            column: 69
          },
          end: {
            line: 688,
            column: 3
          }
        },
        line: 684
      },
      "24": {
        name: "portfolioCtrl_edit",
        decl: {
          start: {
            line: 693,
            column: 9
          },
          end: {
            line: 693,
            column: 27
          }
        },
        loc: {
          start: {
            line: 693,
            column: 109
          },
          end: {
            line: 809,
            column: 1
          }
        },
        line: 693
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 697,
            column: 48
          },
          end: {
            line: 697,
            column: 49
          }
        },
        loc: {
          start: {
            line: 697,
            column: 58
          },
          end: {
            line: 709,
            column: 3
          }
        },
        line: 697
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 718,
            column: 4
          },
          end: {
            line: 718,
            column: 5
          }
        },
        loc: {
          start: {
            line: 718,
            column: 14
          },
          end: {
            line: 734,
            column: 5
          }
        },
        line: 718
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 737,
            column: 24
          },
          end: {
            line: 737,
            column: 25
          }
        },
        loc: {
          start: {
            line: 737,
            column: 36
          },
          end: {
            line: 805,
            column: 3
          }
        },
        line: 737
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 742,
            column: 48
          },
          end: {
            line: 742,
            column: 49
          }
        },
        loc: {
          start: {
            line: 742,
            column: 56
          },
          end: {
            line: 744,
            column: 5
          }
        },
        line: 742
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 800,
            column: 6
          },
          end: {
            line: 800,
            column: 7
          }
        },
        loc: {
          start: {
            line: 800,
            column: 17
          },
          end: {
            line: 803,
            column: 7
          }
        },
        line: 800
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 806,
            column: 22
          },
          end: {
            line: 806,
            column: 23
          }
        },
        loc: {
          start: {
            line: 806,
            column: 34
          },
          end: {
            line: 808,
            column: 3
          }
        },
        line: 806
      },
      "31": {
        name: "Personnalize_1_Ctrl_Project_edit",
        decl: {
          start: {
            line: 811,
            column: 9
          },
          end: {
            line: 811,
            column: 41
          }
        },
        loc: {
          start: {
            line: 811,
            column: 116
          },
          end: {
            line: 900,
            column: 1
          }
        },
        line: 811
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 812,
            column: 23
          },
          end: {
            line: 812,
            column: 24
          }
        },
        loc: {
          start: {
            line: 812,
            column: 35
          },
          end: {
            line: 817,
            column: 3
          }
        },
        line: 812
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 819,
            column: 24
          },
          end: {
            line: 819,
            column: 25
          }
        },
        loc: {
          start: {
            line: 819,
            column: 40
          },
          end: {
            line: 822,
            column: 3
          }
        },
        line: 819
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 824,
            column: 27
          },
          end: {
            line: 824,
            column: 28
          }
        },
        loc: {
          start: {
            line: 824,
            column: 33
          },
          end: {
            line: 826,
            column: 3
          }
        },
        line: 824
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 828,
            column: 28
          },
          end: {
            line: 828,
            column: 29
          }
        },
        loc: {
          start: {
            line: 828,
            column: 39
          },
          end: {
            line: 861,
            column: 3
          }
        },
        line: 828
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 845,
            column: 37
          },
          end: {
            line: 845,
            column: 38
          }
        },
        loc: {
          start: {
            line: 845,
            column: 49
          },
          end: {
            line: 848,
            column: 5
          }
        },
        line: 845
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 856,
            column: 7
          },
          end: {
            line: 856,
            column: 8
          }
        },
        loc: {
          start: {
            line: 856,
            column: 15
          },
          end: {
            line: 860,
            column: 5
          }
        },
        line: 856
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 863,
            column: 27
          },
          end: {
            line: 863,
            column: 28
          }
        },
        loc: {
          start: {
            line: 863,
            column: 35
          },
          end: {
            line: 895,
            column: 3
          }
        },
        line: 863
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 875,
            column: 7
          },
          end: {
            line: 875,
            column: 8
          }
        },
        loc: {
          start: {
            line: 875,
            column: 20
          },
          end: {
            line: 894,
            column: 5
          }
        },
        line: 875
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 883,
            column: 81
          },
          end: {
            line: 883,
            column: 82
          }
        },
        loc: {
          start: {
            line: 883,
            column: 89
          },
          end: {
            line: 893,
            column: 7
          }
        },
        line: 883
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 897,
            column: 22
          },
          end: {
            line: 897,
            column: 23
          }
        },
        loc: {
          start: {
            line: 897,
            column: 34
          },
          end: {
            line: 899,
            column: 3
          }
        },
        line: 897
      },
      "42": {
        name: "Personnalize_2_Ctrl_Project_edit",
        decl: {
          start: {
            line: 902,
            column: 9
          },
          end: {
            line: 902,
            column: 41
          }
        },
        loc: {
          start: {
            line: 902,
            column: 116
          },
          end: {
            line: 1014,
            column: 1
          }
        },
        line: 902
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 903,
            column: 23
          },
          end: {
            line: 903,
            column: 24
          }
        },
        loc: {
          start: {
            line: 903,
            column: 35
          },
          end: {
            line: 908,
            column: 3
          }
        },
        line: 903
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 910,
            column: 24
          },
          end: {
            line: 910,
            column: 25
          }
        },
        loc: {
          start: {
            line: 910,
            column: 40
          },
          end: {
            line: 913,
            column: 3
          }
        },
        line: 910
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 915,
            column: 27
          },
          end: {
            line: 915,
            column: 28
          }
        },
        loc: {
          start: {
            line: 915,
            column: 33
          },
          end: {
            line: 917,
            column: 3
          }
        },
        line: 915
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 939,
            column: 28
          },
          end: {
            line: 939,
            column: 29
          }
        },
        loc: {
          start: {
            line: 939,
            column: 39
          },
          end: {
            line: 972,
            column: 3
          }
        },
        line: 939
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 956,
            column: 37
          },
          end: {
            line: 956,
            column: 38
          }
        },
        loc: {
          start: {
            line: 956,
            column: 49
          },
          end: {
            line: 959,
            column: 5
          }
        },
        line: 956
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 967,
            column: 7
          },
          end: {
            line: 967,
            column: 8
          }
        },
        loc: {
          start: {
            line: 967,
            column: 15
          },
          end: {
            line: 971,
            column: 5
          }
        },
        line: 967
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 977,
            column: 27
          },
          end: {
            line: 977,
            column: 28
          }
        },
        loc: {
          start: {
            line: 977,
            column: 35
          },
          end: {
            line: 1009,
            column: 3
          }
        },
        line: 977
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 989,
            column: 7
          },
          end: {
            line: 989,
            column: 8
          }
        },
        loc: {
          start: {
            line: 989,
            column: 20
          },
          end: {
            line: 1008,
            column: 5
          }
        },
        line: 989
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 997,
            column: 81
          },
          end: {
            line: 997,
            column: 82
          }
        },
        loc: {
          start: {
            line: 997,
            column: 89
          },
          end: {
            line: 1007,
            column: 7
          }
        },
        line: 997
      },
      "52": {
        name: "(anonymous_52)",
        decl: {
          start: {
            line: 1011,
            column: 22
          },
          end: {
            line: 1011,
            column: 23
          }
        },
        loc: {
          start: {
            line: 1011,
            column: 34
          },
          end: {
            line: 1013,
            column: 3
          }
        },
        line: 1011
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }, {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 23
          }
        }, {
          start: {
            line: 28,
            column: 27
          },
          end: {
            line: 28,
            column: 74
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        }, {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 10
          },
          end: {
            line: 38,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 10
          },
          end: {
            line: 36,
            column: 39
          }
        }, {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 31
          }
        }, {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 32
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 293,
            column: 22
          },
          end: {
            line: 293,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 293,
            column: 29
          },
          end: {
            line: 293,
            column: 38
          }
        }],
        line: 293
      },
      "5": {
        loc: {
          start: {
            line: 293,
            column: 40
          },
          end: {
            line: 293,
            column: 52
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 293,
            column: 47
          },
          end: {
            line: 293,
            column: 52
          }
        }],
        line: 293
      },
      "6": {
        loc: {
          start: {
            line: 294,
            column: 6
          },
          end: {
            line: 296,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 294,
            column: 6
          },
          end: {
            line: 296,
            column: 7
          }
        }, {
          start: {
            line: 294,
            column: 6
          },
          end: {
            line: 296,
            column: 7
          }
        }],
        line: 294
      },
      "7": {
        loc: {
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 305,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 305,
            column: 7
          }
        }, {
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 305,
            column: 7
          }
        }],
        line: 303
      },
      "8": {
        loc: {
          start: {
            line: 315,
            column: 8
          },
          end: {
            line: 328,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 315,
            column: 8
          },
          end: {
            line: 328,
            column: 9
          }
        }, {
          start: {
            line: 315,
            column: 8
          },
          end: {
            line: 328,
            column: 9
          }
        }],
        line: 315
      },
      "9": {
        loc: {
          start: {
            line: 316,
            column: 10
          },
          end: {
            line: 322,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 316,
            column: 10
          },
          end: {
            line: 322,
            column: 11
          }
        }, {
          start: {
            line: 316,
            column: 10
          },
          end: {
            line: 322,
            column: 11
          }
        }],
        line: 316
      },
      "10": {
        loc: {
          start: {
            line: 323,
            column: 10
          },
          end: {
            line: 327,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 323,
            column: 10
          },
          end: {
            line: 327,
            column: 11
          }
        }, {
          start: {
            line: 323,
            column: 10
          },
          end: {
            line: 327,
            column: 11
          }
        }],
        line: 323
      },
      "11": {
        loc: {
          start: {
            line: 323,
            column: 14
          },
          end: {
            line: 323,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 323,
            column: 14
          },
          end: {
            line: 323,
            column: 29
          }
        }, {
          start: {
            line: 323,
            column: 33
          },
          end: {
            line: 323,
            column: 48
          }
        }],
        line: 323
      },
      "12": {
        loc: {
          start: {
            line: 331,
            column: 14
          },
          end: {
            line: 331,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 331,
            column: 21
          },
          end: {
            line: 331,
            column: 23
          }
        }],
        line: 331
      },
      "13": {
        loc: {
          start: {
            line: 334,
            column: 6
          },
          end: {
            line: 360,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 334,
            column: 6
          },
          end: {
            line: 360,
            column: 7
          }
        }, {
          start: {
            line: 334,
            column: 6
          },
          end: {
            line: 360,
            column: 7
          }
        }],
        line: 334
      },
      "14": {
        loc: {
          start: {
            line: 337,
            column: 17
          },
          end: {
            line: 337,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 337,
            column: 78
          },
          end: {
            line: 337,
            column: 79
          }
        }, {
          start: {
            line: 337,
            column: 82
          },
          end: {
            line: 337,
            column: 84
          }
        }],
        line: 337
      },
      "15": {
        loc: {
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 352,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 352,
            column: 11
          }
        }, {
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 352,
            column: 11
          }
        }],
        line: 347
      },
      "16": {
        loc: {
          start: {
            line: 364,
            column: 12
          },
          end: {
            line: 364,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 364,
            column: 21
          },
          end: {
            line: 364,
            column: 25
          }
        }],
        line: 364
      },
      "17": {
        loc: {
          start: {
            line: 366,
            column: 6
          },
          end: {
            line: 373,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 366,
            column: 6
          },
          end: {
            line: 373,
            column: 7
          }
        }, {
          start: {
            line: 366,
            column: 6
          },
          end: {
            line: 373,
            column: 7
          }
        }],
        line: 366
      },
      "18": {
        loc: {
          start: {
            line: 366,
            column: 10
          },
          end: {
            line: 366,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 366,
            column: 10
          },
          end: {
            line: 366,
            column: 16
          }
        }, {
          start: {
            line: 366,
            column: 20
          },
          end: {
            line: 366,
            column: 65
          }
        }],
        line: 366
      },
      "19": {
        loc: {
          start: {
            line: 368,
            column: 17
          },
          end: {
            line: 368,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 368,
            column: 17
          },
          end: {
            line: 368,
            column: 72
          }
        }, {
          start: {
            line: 368,
            column: 76
          },
          end: {
            line: 368,
            column: 93
          }
        }],
        line: 368
      },
      "20": {
        loc: {
          start: {
            line: 369,
            column: 16
          },
          end: {
            line: 369,
            column: 212
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 369,
            column: 16
          },
          end: {
            line: 369,
            column: 110
          }
        }, {
          start: {
            line: 369,
            column: 114
          },
          end: {
            line: 369,
            column: 212
          }
        }],
        line: 369
      },
      "21": {
        loc: {
          start: {
            line: 377,
            column: 19
          },
          end: {
            line: 377,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 377,
            column: 20
          },
          end: {
            line: 377,
            column: 50
          }
        }, {
          start: {
            line: 377,
            column: 55
          },
          end: {
            line: 377,
            column: 56
          }
        }],
        line: 377
      },
      "22": {
        loc: {
          start: {
            line: 377,
            column: 20
          },
          end: {
            line: 377,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 377,
            column: 37
          },
          end: {
            line: 377,
            column: 38
          }
        }, {
          start: {
            line: 377,
            column: 41
          },
          end: {
            line: 377,
            column: 50
          }
        }],
        line: 377
      },
      "23": {
        loc: {
          start: {
            line: 445,
            column: 38
          },
          end: {
            line: 447,
            column: 20
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 445,
            column: 38
          },
          end: {
            line: 447,
            column: 7
          }
        }, {
          start: {
            line: 447,
            column: 11
          },
          end: {
            line: 447,
            column: 20
          }
        }],
        line: 445
      },
      "24": {
        loc: {
          start: {
            line: 473,
            column: 9
          },
          end: {
            line: 473,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 473,
            column: 9
          },
          end: {
            line: 473,
            column: 48
          }
        }, {
          start: {
            line: 473,
            column: 52
          },
          end: {
            line: 473,
            column: 56
          }
        }],
        line: 473
      },
      "25": {
        loc: {
          start: {
            line: 525,
            column: 26
          },
          end: {
            line: 525,
            column: 162
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 525,
            column: 27
          },
          end: {
            line: 525,
            column: 54
          }
        }, {
          start: {
            line: 525,
            column: 58
          },
          end: {
            line: 525,
            column: 94
          }
        }, {
          start: {
            line: 525,
            column: 100
          },
          end: {
            line: 525,
            column: 126
          }
        }, {
          start: {
            line: 525,
            column: 130
          },
          end: {
            line: 525,
            column: 161
          }
        }],
        line: 525
      },
      "26": {
        loc: {
          start: {
            line: 526,
            column: 8
          },
          end: {
            line: 530,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 526,
            column: 8
          },
          end: {
            line: 530,
            column: 9
          }
        }, {
          start: {
            line: 526,
            column: 8
          },
          end: {
            line: 530,
            column: 9
          }
        }],
        line: 526
      },
      "27": {
        loc: {
          start: {
            line: 526,
            column: 12
          },
          end: {
            line: 526,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 526,
            column: 12
          },
          end: {
            line: 526,
            column: 21
          }
        }, {
          start: {
            line: 526,
            column: 25
          },
          end: {
            line: 526,
            column: 65
          }
        }],
        line: 526
      },
      "28": {
        loc: {
          start: {
            line: 528,
            column: 27
          },
          end: {
            line: 528,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 528,
            column: 27
          },
          end: {
            line: 528,
            column: 45
          }
        }, {
          start: {
            line: 528,
            column: 49
          },
          end: {
            line: 528,
            column: 58
          }
        }],
        line: 528
      },
      "29": {
        loc: {
          start: {
            line: 537,
            column: 30
          },
          end: {
            line: 537,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 537,
            column: 30
          },
          end: {
            line: 537,
            column: 60
          }
        }, {
          start: {
            line: 537,
            column: 64
          },
          end: {
            line: 537,
            column: 65
          }
        }],
        line: 537
      },
      "30": {
        loc: {
          start: {
            line: 537,
            column: 31
          },
          end: {
            line: 537,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 537,
            column: 31
          },
          end: {
            line: 537,
            column: 43
          }
        }, {
          start: {
            line: 537,
            column: 47
          },
          end: {
            line: 537,
            column: 56
          }
        }],
        line: 537
      },
      "31": {
        loc: {
          start: {
            line: 557,
            column: 10
          },
          end: {
            line: 559,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 557,
            column: 10
          },
          end: {
            line: 559,
            column: 11
          }
        }, {
          start: {
            line: 557,
            column: 10
          },
          end: {
            line: 559,
            column: 11
          }
        }],
        line: 557
      },
      "32": {
        loc: {
          start: {
            line: 565,
            column: 14
          },
          end: {
            line: 572,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 565,
            column: 14
          },
          end: {
            line: 572,
            column: 15
          }
        }, {
          start: {
            line: 565,
            column: 14
          },
          end: {
            line: 572,
            column: 15
          }
        }],
        line: 565
      },
      "33": {
        loc: {
          start: {
            line: 611,
            column: 6
          },
          end: {
            line: 617,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 611,
            column: 6
          },
          end: {
            line: 617,
            column: 7
          }
        }, {
          start: {
            line: 611,
            column: 6
          },
          end: {
            line: 617,
            column: 7
          }
        }],
        line: 611
      },
      "34": {
        loc: {
          start: {
            line: 625,
            column: 28
          },
          end: {
            line: 625,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 625,
            column: 28
          },
          end: {
            line: 625,
            column: 49
          }
        }, {
          start: {
            line: 625,
            column: 53
          },
          end: {
            line: 625,
            column: 55
          }
        }],
        line: 625
      },
      "35": {
        loc: {
          start: {
            line: 626,
            column: 4
          },
          end: {
            line: 631,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 626,
            column: 4
          },
          end: {
            line: 631,
            column: 5
          }
        }, {
          start: {
            line: 626,
            column: 4
          },
          end: {
            line: 631,
            column: 5
          }
        }],
        line: 626
      },
      "36": {
        loc: {
          start: {
            line: 633,
            column: 6
          },
          end: {
            line: 637,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 633,
            column: 6
          },
          end: {
            line: 637,
            column: 7
          }
        }, {
          start: {
            line: 633,
            column: 6
          },
          end: {
            line: 637,
            column: 7
          }
        }],
        line: 633
      },
      "37": {
        loc: {
          start: {
            line: 643,
            column: 28
          },
          end: {
            line: 643,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 643,
            column: 28
          },
          end: {
            line: 643,
            column: 49
          }
        }, {
          start: {
            line: 643,
            column: 53
          },
          end: {
            line: 643,
            column: 55
          }
        }],
        line: 643
      },
      "38": {
        loc: {
          start: {
            line: 644,
            column: 4
          },
          end: {
            line: 649,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 644,
            column: 4
          },
          end: {
            line: 649,
            column: 5
          }
        }, {
          start: {
            line: 644,
            column: 4
          },
          end: {
            line: 649,
            column: 5
          }
        }],
        line: 644
      },
      "39": {
        loc: {
          start: {
            line: 651,
            column: 6
          },
          end: {
            line: 655,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 651,
            column: 6
          },
          end: {
            line: 655,
            column: 7
          }
        }, {
          start: {
            line: 651,
            column: 6
          },
          end: {
            line: 655,
            column: 7
          }
        }],
        line: 651
      },
      "40": {
        loc: {
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 687,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 687,
            column: 5
          }
        }, {
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 687,
            column: 5
          }
        }],
        line: 685
      },
      "41": {
        loc: {
          start: {
            line: 685,
            column: 8
          },
          end: {
            line: 685,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 685,
            column: 8
          },
          end: {
            line: 685,
            column: 14
          }
        }, {
          start: {
            line: 685,
            column: 18
          },
          end: {
            line: 685,
            column: 42
          }
        }],
        line: 685
      },
      "42": {
        loc: {
          start: {
            line: 715,
            column: 10
          },
          end: {
            line: 715,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 715,
            column: 10
          },
          end: {
            line: 715,
            column: 37
          }
        }, {
          start: {
            line: 715,
            column: 41
          },
          end: {
            line: 715,
            column: 42
          }
        }],
        line: 715
      },
      "43": {
        loc: {
          start: {
            line: 719,
            column: 6
          },
          end: {
            line: 724,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 719,
            column: 6
          },
          end: {
            line: 724,
            column: 7
          }
        }, {
          start: {
            line: 719,
            column: 6
          },
          end: {
            line: 724,
            column: 7
          }
        }],
        line: 719
      },
      "44": {
        loc: {
          start: {
            line: 726,
            column: 6
          },
          end: {
            line: 731,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 726,
            column: 6
          },
          end: {
            line: 731,
            column: 7
          }
        }, {
          start: {
            line: 726,
            column: 6
          },
          end: {
            line: 731,
            column: 7
          }
        }],
        line: 726
      },
      "45": {
        loc: {
          start: {
            line: 743,
            column: 13
          },
          end: {
            line: 743,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 743,
            column: 13
          },
          end: {
            line: 743,
            column: 56
          }
        }, {
          start: {
            line: 743,
            column: 60
          },
          end: {
            line: 743,
            column: 76
          }
        }],
        line: 743
      },
      "46": {
        loc: {
          start: {
            line: 746,
            column: 4
          },
          end: {
            line: 749,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 746,
            column: 4
          },
          end: {
            line: 749,
            column: 5
          }
        }, {
          start: {
            line: 746,
            column: 4
          },
          end: {
            line: 749,
            column: 5
          }
        }],
        line: 746
      },
      "47": {
        loc: {
          start: {
            line: 832,
            column: 4
          },
          end: {
            line: 836,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 832,
            column: 4
          },
          end: {
            line: 836,
            column: 5
          }
        }, {
          start: {
            line: 832,
            column: 4
          },
          end: {
            line: 836,
            column: 5
          }
        }],
        line: 832
      },
      "48": {
        loc: {
          start: {
            line: 832,
            column: 8
          },
          end: {
            line: 832,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 832,
            column: 8
          },
          end: {
            line: 832,
            column: 30
          }
        }, {
          start: {
            line: 832,
            column: 34
          },
          end: {
            line: 832,
            column: 71
          }
        }],
        line: 832
      },
      "49": {
        loc: {
          start: {
            line: 839,
            column: 4
          },
          end: {
            line: 842,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 839,
            column: 4
          },
          end: {
            line: 842,
            column: 5
          }
        }, {
          start: {
            line: 839,
            column: 4
          },
          end: {
            line: 842,
            column: 5
          }
        }],
        line: 839
      },
      "50": {
        loc: {
          start: {
            line: 839,
            column: 8
          },
          end: {
            line: 839,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 839,
            column: 8
          },
          end: {
            line: 839,
            column: 32
          }
        }, {
          start: {
            line: 839,
            column: 36
          },
          end: {
            line: 839,
            column: 65
          }
        }],
        line: 839
      },
      "51": {
        loc: {
          start: {
            line: 845,
            column: 4
          },
          end: {
            line: 851,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 845,
            column: 4
          },
          end: {
            line: 851,
            column: 5
          }
        }, {
          start: {
            line: 845,
            column: 4
          },
          end: {
            line: 851,
            column: 5
          }
        }],
        line: 845
      },
      "52": {
        loc: {
          start: {
            line: 846,
            column: 15
          },
          end: {
            line: 847,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 846,
            column: 15
          },
          end: {
            line: 846,
            column: 89
          }
        }, {
          start: {
            line: 847,
            column: 18
          },
          end: {
            line: 847,
            column: 59
          }
        }],
        line: 846
      },
      "53": {
        loc: {
          start: {
            line: 876,
            column: 6
          },
          end: {
            line: 878,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 876,
            column: 6
          },
          end: {
            line: 878,
            column: 7
          }
        }, {
          start: {
            line: 876,
            column: 6
          },
          end: {
            line: 878,
            column: 7
          }
        }],
        line: 876
      },
      "54": {
        loc: {
          start: {
            line: 884,
            column: 8
          },
          end: {
            line: 891,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 884,
            column: 8
          },
          end: {
            line: 891,
            column: 9
          }
        }, {
          start: {
            line: 884,
            column: 8
          },
          end: {
            line: 891,
            column: 9
          }
        }],
        line: 884
      },
      "55": {
        loc: {
          start: {
            line: 943,
            column: 4
          },
          end: {
            line: 947,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 943,
            column: 4
          },
          end: {
            line: 947,
            column: 5
          }
        }, {
          start: {
            line: 943,
            column: 4
          },
          end: {
            line: 947,
            column: 5
          }
        }],
        line: 943
      },
      "56": {
        loc: {
          start: {
            line: 943,
            column: 8
          },
          end: {
            line: 943,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 943,
            column: 8
          },
          end: {
            line: 943,
            column: 30
          }
        }, {
          start: {
            line: 943,
            column: 34
          },
          end: {
            line: 943,
            column: 71
          }
        }],
        line: 943
      },
      "57": {
        loc: {
          start: {
            line: 950,
            column: 4
          },
          end: {
            line: 953,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 950,
            column: 4
          },
          end: {
            line: 953,
            column: 5
          }
        }, {
          start: {
            line: 950,
            column: 4
          },
          end: {
            line: 953,
            column: 5
          }
        }],
        line: 950
      },
      "58": {
        loc: {
          start: {
            line: 950,
            column: 8
          },
          end: {
            line: 950,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 950,
            column: 8
          },
          end: {
            line: 950,
            column: 32
          }
        }, {
          start: {
            line: 950,
            column: 36
          },
          end: {
            line: 950,
            column: 65
          }
        }],
        line: 950
      },
      "59": {
        loc: {
          start: {
            line: 956,
            column: 4
          },
          end: {
            line: 962,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 956,
            column: 4
          },
          end: {
            line: 962,
            column: 5
          }
        }, {
          start: {
            line: 956,
            column: 4
          },
          end: {
            line: 962,
            column: 5
          }
        }],
        line: 956
      },
      "60": {
        loc: {
          start: {
            line: 957,
            column: 15
          },
          end: {
            line: 958,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 957,
            column: 15
          },
          end: {
            line: 957,
            column: 89
          }
        }, {
          start: {
            line: 958,
            column: 18
          },
          end: {
            line: 958,
            column: 59
          }
        }],
        line: 957
      },
      "61": {
        loc: {
          start: {
            line: 990,
            column: 6
          },
          end: {
            line: 992,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 990,
            column: 6
          },
          end: {
            line: 992,
            column: 7
          }
        }, {
          start: {
            line: 990,
            column: 6
          },
          end: {
            line: 992,
            column: 7
          }
        }],
        line: 990
      },
      "62": {
        loc: {
          start: {
            line: 998,
            column: 8
          },
          end: {
            line: 1005,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 998,
            column: 8
          },
          end: {
            line: 1005,
            column: 9
          }
        }, {
          start: {
            line: 998,
            column: 8
          },
          end: {
            line: 1005,
            column: 9
          }
        }],
        line: 998
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0,
      "237": 0,
      "238": 0,
      "239": 0,
      "240": 0,
      "241": 0,
      "242": 0,
      "243": 0,
      "244": 0,
      "245": 0,
      "246": 0,
      "247": 0,
      "248": 0,
      "249": 0,
      "250": 0,
      "251": 0,
      "252": 0,
      "253": 0,
      "254": 0,
      "255": 0,
      "256": 0,
      "257": 0,
      "258": 0,
      "259": 0,
      "260": 0,
      "261": 0,
      "262": 0,
      "263": 0,
      "264": 0,
      "265": 0,
      "266": 0,
      "267": 0,
      "268": 0,
      "269": 0,
      "270": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0, 0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0]
    },
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2ferdkoho4.s[0]++;
angular.module("app").controller("PortfolioCtrl", function ($scope, $rootScope, $state, $uibModal, $translate, $stateParams, $CRUDService, FileUploader, SweetAlert, $deltahttp, $log, $document) {
  cov_2ferdkoho4.f[0]++;

  var PATH = (cov_2ferdkoho4.s[1]++, "Projet");

  cov_2ferdkoho4.s[2]++;
  $rootScope.processPageRight("1_1", function () {
    cov_2ferdkoho4.f[1]++;
    cov_2ferdkoho4.s[3]++;

    $rootScope.global_access_page_denied = false;
    cov_2ferdkoho4.s[4]++;
    $rootScope.currentRight.v = true;
  });
  cov_2ferdkoho4.s[5]++;
  $rootScope.clearProject();
  cov_2ferdkoho4.s[6]++;
  if (!$rootScope.connectedUser.finalSuperAdmin) {
    cov_2ferdkoho4.b[0][0]++;
    cov_2ferdkoho4.s[7]++;

    $rootScope.connectedUser.isAdmin = false;
    cov_2ferdkoho4.s[8]++;
    $rootScope.connectedUser.superAdmin = false;
  } else {
    cov_2ferdkoho4.b[0][1]++;
  }
  cov_2ferdkoho4.s[9]++;
  $rootScope.homePortfolio = true;

  cov_2ferdkoho4.s[10]++;
  $scope.view = {
    filter: "",
    defaultTitle: "",
    tmpDefaultTitle: "",
    displayType: true,
    currentDate: new Date(),
    historic: [],
    portfolios: [],
    opened: {},

    maxPortfolioDepth: 3, canAddSubPortfolio: function canAddSubPortfolio(portfolio) {
      cov_2ferdkoho4.s[11]++;

      return (cov_2ferdkoho4.b[1][0]++, !portfolio) || (cov_2ferdkoho4.b[1][1]++, portfolio.level < $scope.view.maxPortfolioDepth);
    },
    addSubPortfolio: function addSubPortfolio(id) {
      cov_2ferdkoho4.s[12]++;

      this.opened[id] = !this.opened[id];
    },
    filterProcess: function filterProcess(item, index, items) {
      cov_2ferdkoho4.s[13]++;

      for (var _iterator = Object.keys($scope.view.opened), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var id = _ref;
        cov_2ferdkoho4.s[14]++;

        if ((cov_2ferdkoho4.b[3][0]++, item.custom_id.startsWith(id)) && (cov_2ferdkoho4.b[3][1]++, item.custom_id !== id) && (cov_2ferdkoho4.b[3][2]++, $scope.view.opened[id])) {
          cov_2ferdkoho4.b[2][0]++;
          cov_2ferdkoho4.s[15]++;

          return false;
        } else {
          cov_2ferdkoho4.b[2][1]++;
        }
      }
      cov_2ferdkoho4.s[16]++;
      return true;
    },

    contries: [{ id: 1, name: $translate.instant("COUNTRIES.AF") }, { id: 2, name: $translate.instant("COUNTRIES.AX") }, { id: 3, name: $translate.instant("COUNTRIES.AL") }, { id: 4, name: $translate.instant("COUNTRIES.DZ") }, { id: 5, name: $translate.instant("COUNTRIES.AS") }, { id: 6, name: $translate.instant("COUNTRIES.AD") }, { id: 7, name: $translate.instant("COUNTRIES.AO") }, { id: 8, name: $translate.instant("COUNTRIES.AI") }, { id: 9, name: $translate.instant("COUNTRIES.AQ") }, { id: 10, name: $translate.instant("COUNTRIES.AG") }, { id: 11, name: $translate.instant("COUNTRIES.AR") }, { id: 12, name: $translate.instant("COUNTRIES.AM") }, { id: 13, name: $translate.instant("COUNTRIES.AW") }, { id: 14, name: $translate.instant("COUNTRIES.AU") }, { id: 15, name: $translate.instant("COUNTRIES.AT") }, { id: 16, name: $translate.instant("COUNTRIES.AZ") }, { id: 17, name: $translate.instant("COUNTRIES.BS") }, { id: 18, name: $translate.instant("COUNTRIES.BH") }, { id: 19, name: $translate.instant("COUNTRIES.BD") }, { id: 20, name: $translate.instant("COUNTRIES.BB") }, { id: 21, name: $translate.instant("COUNTRIES.BY") }, { id: 22, name: $translate.instant("COUNTRIES.BE") }, { id: 23, name: $translate.instant("COUNTRIES.BZ") }, { id: 24, name: $translate.instant("COUNTRIES.BJ") }, { id: 25, name: $translate.instant("COUNTRIES.BM") }, { id: 26, name: $translate.instant("COUNTRIES.BT") }, { id: 27, name: $translate.instant("COUNTRIES.BO") }, { id: 28, name: $translate.instant("COUNTRIES.BA") }, { id: 29, name: $translate.instant("COUNTRIES.BW") }, { id: 30, name: $translate.instant("COUNTRIES.BV") }, { id: 31, name: $translate.instant("COUNTRIES.BR") }, { id: 32, name: $translate.instant("COUNTRIES.IO") }, { id: 33, name: $translate.instant("COUNTRIES.BN") }, { id: 34, name: $translate.instant("COUNTRIES.BG") }, { id: 35, name: $translate.instant("COUNTRIES.BF") }, { id: 36, name: $translate.instant("COUNTRIES.BI") }, { id: 37, name: $translate.instant("COUNTRIES.KH") }, { id: 38, name: $translate.instant("COUNTRIES.CM") }, { id: 39, name: $translate.instant("COUNTRIES.CA") }, { id: 40, name: $translate.instant("COUNTRIES.CV") }, { id: 41, name: $translate.instant("COUNTRIES.KY") }, { id: 42, name: $translate.instant("COUNTRIES.CF") }, { id: 43, name: $translate.instant("COUNTRIES.TD") }, { id: 44, name: $translate.instant("COUNTRIES.CL") }, { id: 45, name: $translate.instant("COUNTRIES.CN") }, { id: 46, name: $translate.instant("COUNTRIES.CX") }, { id: 47, name: $translate.instant("COUNTRIES.CC") }, { id: 48, name: $translate.instant("COUNTRIES.CO") }, { id: 49, name: $translate.instant("COUNTRIES.KM") }, { id: 50, name: $translate.instant("COUNTRIES.CG") }, { id: 51, name: $translate.instant("COUNTRIES.CD") }, { id: 52, name: $translate.instant("COUNTRIES.CK") }, { id: 53, name: $translate.instant("COUNTRIES.CR") }, { id: 54, name: $translate.instant("COUNTRIES.CI") }, { id: 55, name: $translate.instant("COUNTRIES.HR") }, { id: 56, name: $translate.instant("COUNTRIES.CU") }, { id: 57, name: $translate.instant("COUNTRIES.CY") }, { id: 58, name: $translate.instant("COUNTRIES.CZ") }, { id: 59, name: $translate.instant("COUNTRIES.DK") }, { id: 60, name: $translate.instant("COUNTRIES.DJ") }, { id: 61, name: $translate.instant("COUNTRIES.DM") }, { id: 62, name: $translate.instant("COUNTRIES.DO") }, { id: 63, name: $translate.instant("COUNTRIES.EC") }, { id: 64, name: $translate.instant("COUNTRIES.EG") }, { id: 65, name: $translate.instant("COUNTRIES.SV") }, { id: 66, name: $translate.instant("COUNTRIES.GQ") }, { id: 67, name: $translate.instant("COUNTRIES.ER") }, { id: 68, name: $translate.instant("COUNTRIES.EE") }, { id: 69, name: $translate.instant("COUNTRIES.ET") }, { id: 70, name: $translate.instant("COUNTRIES.FK") }, { id: 71, name: $translate.instant("COUNTRIES.FO") }, { id: 72, name: $translate.instant("COUNTRIES.FJ") }, { id: 73, name: $translate.instant("COUNTRIES.FI") }, { id: 74, name: $translate.instant("COUNTRIES.FR") }, { id: 75, name: $translate.instant("COUNTRIES.GF") }, { id: 76, name: $translate.instant("COUNTRIES.PF") }, { id: 77, name: $translate.instant("COUNTRIES.TF") }, { id: 78, name: $translate.instant("COUNTRIES.GA") }, { id: 79, name: $translate.instant("COUNTRIES.GM") }, { id: 80, name: $translate.instant("COUNTRIES.GE") }, { id: 81, name: $translate.instant("COUNTRIES.DE") }, { id: 82, name: $translate.instant("COUNTRIES.GH") }, { id: 83, name: $translate.instant("COUNTRIES.GI") }, { id: 84, name: $translate.instant("COUNTRIES.GR") }, { id: 85, name: $translate.instant("COUNTRIES.GL") }, { id: 86, name: $translate.instant("COUNTRIES.GD") }, { id: 87, name: $translate.instant("COUNTRIES.GP") }, { id: 88, name: $translate.instant("COUNTRIES.GU") }, { id: 89, name: $translate.instant("COUNTRIES.GT") }, { id: 90, name: $translate.instant("COUNTRIES.GG") }, { id: 91, name: $translate.instant("COUNTRIES.GN") }, { id: 92, name: $translate.instant("COUNTRIES.GW") }, { id: 93, name: $translate.instant("COUNTRIES.GY") }, { id: 94, name: $translate.instant("COUNTRIES.HT") }, { id: 95, name: $translate.instant("COUNTRIES.HM") }, { id: 96, name: $translate.instant("COUNTRIES.VA") }, { id: 97, name: $translate.instant("COUNTRIES.HN") }, { id: 98, name: $translate.instant("COUNTRIES.HK") }, { id: 99, name: $translate.instant("COUNTRIES.HU") }, { id: 100, name: $translate.instant("COUNTRIES.IS") }, { id: 101, name: $translate.instant("COUNTRIES.IN") }, { id: 102, name: $translate.instant("COUNTRIES.ID") }, { id: 103, name: $translate.instant("COUNTRIES.IR") }, { id: 104, name: $translate.instant("COUNTRIES.IQ") }, { id: 105, name: $translate.instant("COUNTRIES.IE") }, { id: 106, name: $translate.instant("COUNTRIES.IM") }, { id: 107, name: $translate.instant("COUNTRIES.IL") }, { id: 108, name: $translate.instant("COUNTRIES.IT") }, { id: 109, name: $translate.instant("COUNTRIES.JM") }, { id: 110, name: $translate.instant("COUNTRIES.JP") }, { id: 111, name: $translate.instant("COUNTRIES.JE") }, { id: 112, name: $translate.instant("COUNTRIES.JO") }, { id: 113, name: $translate.instant("COUNTRIES.KZ") }, { id: 114, name: $translate.instant("COUNTRIES.KE") }, { id: 115, name: $translate.instant("COUNTRIES.KI") }, { id: 116, name: $translate.instant("COUNTRIES.KP") }, { id: 117, name: $translate.instant("COUNTRIES.KR") }, { id: 118, name: $translate.instant("COUNTRIES.KW") }, { id: 119, name: $translate.instant("COUNTRIES.KG") }, { id: 120, name: $translate.instant("COUNTRIES.LA") }, { id: 121, name: $translate.instant("COUNTRIES.LV") }, { id: 122, name: $translate.instant("COUNTRIES.LB") }, { id: 123, name: $translate.instant("COUNTRIES.LS") }, { id: 124, name: $translate.instant("COUNTRIES.LR") }, { id: 125, name: $translate.instant("COUNTRIES.LY") }, { id: 126, name: $translate.instant("COUNTRIES.LI") }, { id: 127, name: $translate.instant("COUNTRIES.LT") }, { id: 128, name: $translate.instant("COUNTRIES.LU") }, { id: 129, name: $translate.instant("COUNTRIES.MO") }, { id: 130, name: $translate.instant("COUNTRIES.MK") }, { id: 131, name: $translate.instant("COUNTRIES.MG") }, { id: 132, name: $translate.instant("COUNTRIES.MW") }, { id: 133, name: $translate.instant("COUNTRIES.MY") }, { id: 134, name: $translate.instant("COUNTRIES.MV") }, { id: 135, name: $translate.instant("COUNTRIES.ML") }, { id: 136, name: $translate.instant("COUNTRIES.MT") }, { id: 137, name: $translate.instant("COUNTRIES.MH") }, { id: 138, name: $translate.instant("COUNTRIES.MQ") }, { id: 139, name: $translate.instant("COUNTRIES.MR") }, { id: 140, name: $translate.instant("COUNTRIES.MU") }, { id: 141, name: $translate.instant("COUNTRIES.YT") }, { id: 142, name: $translate.instant("COUNTRIES.MX") }, { id: 143, name: $translate.instant("COUNTRIES.FM") }, { id: 144, name: $translate.instant("COUNTRIES.MD") }, { id: 145, name: $translate.instant("COUNTRIES.MC") }, { id: 146, name: $translate.instant("COUNTRIES.MN") }, { id: 147, name: $translate.instant("COUNTRIES.MS") }, { id: 148, name: $translate.instant("COUNTRIES.MA") }, { id: 149, name: $translate.instant("COUNTRIES.MZ") }, { id: 150, name: $translate.instant("COUNTRIES.MM") }, { id: 151, name: $translate.instant("COUNTRIES.NA") }, { id: 152, name: $translate.instant("COUNTRIES.NR") }, { id: 153, name: $translate.instant("COUNTRIES.NP") }, { id: 154, name: $translate.instant("COUNTRIES.NL") }, { id: 155, name: $translate.instant("COUNTRIES.AN") }, { id: 156, name: $translate.instant("COUNTRIES.NC") }, { id: 157, name: $translate.instant("COUNTRIES.NZ") }, { id: 158, name: $translate.instant("COUNTRIES.NI") }, { id: 159, name: $translate.instant("COUNTRIES.NE") }, { id: 160, name: $translate.instant("COUNTRIES.NG") }, { id: 161, name: $translate.instant("COUNTRIES.NU") }, { id: 162, name: $translate.instant("COUNTRIES.NF") }, { id: 163, name: $translate.instant("COUNTRIES.MP") }, { id: 164, name: $translate.instant("COUNTRIES.NO") }, { id: 165, name: $translate.instant("COUNTRIES.OM") }, { id: 166, name: $translate.instant("COUNTRIES.PK") }, { id: 167, name: $translate.instant("COUNTRIES.PW") }, { id: 168, name: $translate.instant("COUNTRIES.PS") }, { id: 169, name: $translate.instant("COUNTRIES.PA") }, { id: 170, name: $translate.instant("COUNTRIES.PG") }, { id: 171, name: $translate.instant("COUNTRIES.PY") }, { id: 172, name: $translate.instant("COUNTRIES.PE") }, { id: 173, name: $translate.instant("COUNTRIES.PH") }, { id: 174, name: $translate.instant("COUNTRIES.PN") }, { id: 175, name: $translate.instant("COUNTRIES.PL") }, { id: 176, name: $translate.instant("COUNTRIES.PT") }, { id: 177, name: $translate.instant("COUNTRIES.PR") }, { id: 178, name: $translate.instant("COUNTRIES.QA") }, { id: 179, name: $translate.instant("COUNTRIES.RE") }, { id: 180, name: $translate.instant("COUNTRIES.RO") }, { id: 181, name: $translate.instant("COUNTRIES.RU") }, { id: 182, name: $translate.instant("COUNTRIES.RW") }, { id: 183, name: $translate.instant("COUNTRIES.SH") }, { id: 184, name: $translate.instant("COUNTRIES.KN") }, { id: 185, name: $translate.instant("COUNTRIES.LC") }, { id: 186, name: $translate.instant("COUNTRIES.PM") }, { id: 187, name: $translate.instant("COUNTRIES.VC") }, { id: 188, name: $translate.instant("COUNTRIES.WS") }, { id: 189, name: $translate.instant("COUNTRIES.SM") }, { id: 190, name: $translate.instant("COUNTRIES.ST") }, { id: 191, name: $translate.instant("COUNTRIES.SA") }, { id: 192, name: $translate.instant("COUNTRIES.SN") }, { id: 193, name: $translate.instant("COUNTRIES.CS") }, { id: 194, name: $translate.instant("COUNTRIES.SC") }, { id: 195, name: $translate.instant("COUNTRIES.SL") }, { id: 196, name: $translate.instant("COUNTRIES.SG") }, { id: 197, name: $translate.instant("COUNTRIES.SK") }, { id: 198, name: $translate.instant("COUNTRIES.SI") }, { id: 199, name: $translate.instant("COUNTRIES.SB") }, { id: 200, name: $translate.instant("COUNTRIES.SO") }, { id: 201, name: $translate.instant("COUNTRIES.ZA") }, { id: 202, name: $translate.instant("COUNTRIES.GS") }, { id: 203, name: $translate.instant("COUNTRIES.ES") }, { id: 204, name: $translate.instant("COUNTRIES.LK") }, { id: 205, name: $translate.instant("COUNTRIES.SD") }, { id: 206, name: $translate.instant("COUNTRIES.SR") }, { id: 207, name: $translate.instant("COUNTRIES.SJ") }, { id: 208, name: $translate.instant("COUNTRIES.SZ") }, { id: 209, name: $translate.instant("COUNTRIES.SE") }, { id: 210, name: $translate.instant("COUNTRIES.CH") }, { id: 211, name: $translate.instant("COUNTRIES.SY") }, { id: 212, name: $translate.instant("COUNTRIES.TW") }, { id: 213, name: $translate.instant("COUNTRIES.TJ") }, { id: 214, name: $translate.instant("COUNTRIES.TZ") }, { id: 215, name: $translate.instant("COUNTRIES.TH") }, { id: 216, name: $translate.instant("COUNTRIES.TL") }, { id: 217, name: $translate.instant("COUNTRIES.TG") }, { id: 218, name: $translate.instant("COUNTRIES.TK") }, { id: 219, name: $translate.instant("COUNTRIES.TO") }, { id: 220, name: $translate.instant("COUNTRIES.TT") }, { id: 221, name: $translate.instant("COUNTRIES.TN") }, { id: 222, name: $translate.instant("COUNTRIES.TR") }, { id: 223, name: $translate.instant("COUNTRIES.TM") }, { id: 224, name: $translate.instant("COUNTRIES.TC") }, { id: 225, name: $translate.instant("COUNTRIES.TV") }, { id: 226, name: $translate.instant("COUNTRIES.UG") }, { id: 227, name: $translate.instant("COUNTRIES.UA") }, { id: 228, name: $translate.instant("COUNTRIES.AE") }, { id: 229, name: $translate.instant("COUNTRIES.GB") }, { id: 230, name: $translate.instant("COUNTRIES.US") }, { id: 231, name: $translate.instant("COUNTRIES.UM") }, { id: 232, name: $translate.instant("COUNTRIES.UY") }, { id: 233, name: $translate.instant("COUNTRIES.UZ") }, { id: 234, name: $translate.instant("COUNTRIES.VU") }, { id: 235, name: $translate.instant("COUNTRIES.VE") }, { id: 236, name: $translate.instant("COUNTRIES.VN") }, { id: 237, name: $translate.instant("COUNTRIES.VG") }, { id: 238, name: $translate.instant("COUNTRIES.VI") }, { id: 239, name: $translate.instant("COUNTRIES.WF") }, { id: 240, name: $translate.instant("COUNTRIES.EH") }, { id: 241, name: $translate.instant("COUNTRIES.YE") }, { id: 242, name: $translate.instant("COUNTRIES.ZM") }, { id: 243, name: $translate.instant("COUNTRIES.ZW") }],
    selectPortfolioImage: function selectPortfolioImage(portfolio) {
      cov_2ferdkoho4.s[17]++;

      this.selectedPortfolioImage = portfolio;
    },
    loadSupPortefolio: function loadSupPortefolio() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2ferdkoho4.b[4][0]++, { id: 0 });
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2ferdkoho4.b[5][0]++, false);
      cov_2ferdkoho4.s[18]++;

      if (last) {
        cov_2ferdkoho4.b[6][0]++;
        cov_2ferdkoho4.s[19]++;

        return;
      } else {
        cov_2ferdkoho4.b[6][1]++;
      }
      cov_2ferdkoho4.s[20]++;
      $state.go("index.sub-portfolio", { id: item.id });
    },
    goToProject: function goToProject(portfolio) {
      cov_2ferdkoho4.s[21]++;

      $rootScope.homePortfolio = false;

      cov_2ferdkoho4.s[22]++;
      $scope.view.checkLangUpdate();
      cov_2ferdkoho4.s[23]++;
      if (!portfolio.CAN_SELECT) {
        cov_2ferdkoho4.b[7][0]++;
        cov_2ferdkoho4.s[24]++;

        return;
      } else {
        cov_2ferdkoho4.b[7][1]++;
      }
      cov_2ferdkoho4.s[25]++;
      localStorage.removeItem("gobackportfolio");
      cov_2ferdkoho4.s[26]++;
      localStorage.setItem("PORTFOLIO_ID_KEY", portfolio.id);
      cov_2ferdkoho4.s[27]++;
      $deltahttp.setProject(portfolio.id);

      cov_2ferdkoho4.s[28]++;
      $state.go("index.projects");
    },
    checkLangUpdate: function checkLangUpdate() {
      cov_2ferdkoho4.s[29]++;

      $CRUDService.getAll('Connexion', { get: "translateState" }, function (response) {
        cov_2ferdkoho4.f[2]++;
        cov_2ferdkoho4.s[30]++;

        $log.log('DELTA_TRANSLATE =' + response);
        cov_2ferdkoho4.s[31]++;
        if (window.localStorage) {
          cov_2ferdkoho4.b[8][0]++;
          cov_2ferdkoho4.s[32]++;

          if (response == '2') {
            cov_2ferdkoho4.b[9][0]++;
            cov_2ferdkoho4.s[33]++;

            localStorage.removeItem('TRANSLATE_fr');
            cov_2ferdkoho4.s[34]++;
            localStorage.removeItem('TRANSLATE_en');
            cov_2ferdkoho4.s[35]++;
            localStorage.removeItem('TRANSLATE_ar');
            cov_2ferdkoho4.s[36]++;
            localStorage.removeItem('TRANSLATE_es');
            cov_2ferdkoho4.s[37]++;
            localStorage.removeItem('TRANSLATE_pt');
          } else {
            cov_2ferdkoho4.b[9][1]++;
          }
          cov_2ferdkoho4.s[38]++;
          if ((cov_2ferdkoho4.b[11][0]++, response == '2') || (cov_2ferdkoho4.b[11][1]++, response == '1')) {
            cov_2ferdkoho4.b[10][0]++;
            cov_2ferdkoho4.s[39]++;

            localStorage.removeItem('DELTA_TRANSLATE');
          } else {
            cov_2ferdkoho4.b[10][1]++;
            cov_2ferdkoho4.s[40]++;

            localStorage.setItem('DELTA_TRANSLATE', parseInt(response));
          }
        } else {
          cov_2ferdkoho4.b[8][1]++;
        }
      });
    },
    buildTree: function buildTree() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2ferdkoho4.b[12][0]++, []);

      var root = (cov_2ferdkoho4.s[41]++, { children: [], id: 0 });
      var mapping = (cov_2ferdkoho4.s[42]++, {});
      cov_2ferdkoho4.s[43]++;
      if (angular.isArray(data)) {
        cov_2ferdkoho4.b[13][0]++;
        cov_2ferdkoho4.s[44]++;

        data.sort(function (first, second) {
          cov_2ferdkoho4.f[3]++;
          cov_2ferdkoho4.s[45]++;

          return first.ID_PARENT.toString() > second.ID_PARENT.toString() ? (cov_2ferdkoho4.b[14][0]++, 1) : (cov_2ferdkoho4.b[14][1]++, -1);
        });

        cov_2ferdkoho4.s[46]++;
        data.forEach(function (portfolio) {
          cov_2ferdkoho4.f[4]++;
          cov_2ferdkoho4.s[47]++;

          mapping[portfolio.id] = portfolio;
        });

        cov_2ferdkoho4.s[48]++;
        data.forEach(function (portfolio) {
          cov_2ferdkoho4.f[5]++;

          var parent = (cov_2ferdkoho4.s[49]++, mapping[portfolio.ID_PARENT]);

          cov_2ferdkoho4.s[50]++;
          if (parent) {
            cov_2ferdkoho4.b[15][0]++;
            cov_2ferdkoho4.s[51]++;

            portfolio.custom_id = parent.custom_id + "_" + portfolio.id;
            cov_2ferdkoho4.s[52]++;
            parent.hasChild = true;
          } else {
            cov_2ferdkoho4.b[15][1]++;
            cov_2ferdkoho4.s[53]++;

            portfolio.custom_id = "0_" + portfolio.id;
          }

          cov_2ferdkoho4.s[54]++;
          portfolio.level = portfolio.custom_id.split("_").length - 1;
        });
      } else {
        cov_2ferdkoho4.b[13][1]++;
      }

      cov_2ferdkoho4.s[55]++;
      return data;
    },
    addItem: function addItem() {
      var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2ferdkoho4.b[16][0]++, null);
      cov_2ferdkoho4.s[56]++;

      if ((cov_2ferdkoho4.b[18][0]++, parent) && (cov_2ferdkoho4.b[18][1]++, parent.level >= $scope.view.maxPortfolioDepth)) {
        cov_2ferdkoho4.b[17][0]++;
        cov_2ferdkoho4.s[57]++;

        SweetAlert.swal({
          title: (cov_2ferdkoho4.b[19][0]++, $translate.instant("PORTFOLIO.MAX_DEPTH_REACHED_TITLE")) || (cov_2ferdkoho4.b[19][1]++, "Limite atteinte"),
          text: (cov_2ferdkoho4.b[20][0]++, $translate.instant("PORTFOLIO.MAX_DEPTH_REACHED_TEXT", { max: $scope.view.maxPortfolioDepth })) || (cov_2ferdkoho4.b[20][1]++, "Vous ne pouvez pas cr\xE9er plus de " + $scope.view.maxPortfolioDepth + " niveaux de sous-portefeuilles."),
          type: "warning"
        });
        cov_2ferdkoho4.s[58]++;
        return;
      } else {
        cov_2ferdkoho4.b[17][1]++;
      }
      var date = (cov_2ferdkoho4.s[59]++, Date.newDate());
      cov_2ferdkoho4.s[60]++;
      date.setMonth(date.getMonth() + 120);
      cov_2ferdkoho4.s[61]++;
      this.editItem({
        ID_PARENT: (cov_2ferdkoho4.b[21][0]++, parent == null ? (cov_2ferdkoho4.b[22][0]++, 0) : (cov_2ferdkoho4.b[22][1]++, parent.id)) || (cov_2ferdkoho4.b[21][1]++, 0),
        ID_PROGRAM: 0,
        PORTFOLIO: 1,
        ADR_PROJET: "",
        AG_EXE_PROJET: "",
        CODE_ESPACE: "",
        CODE_PRJ: "",
        DATE_DEB_PROJET: Date.newDate(),
        DATE_FIN_PROJET: date,
        DESCRIPTION_PROJET: "",
        Format_cout: "",
        ID_LOG_FRAME: 0,
        LIBELLE_PROJET: "",
        PAYS_PROJET: 230,
        LINK_PG: 0,
        FAX_PROJET: "",
        EMAIL_PROJET: "",
        TEL_PROJET: "",
        id: 0,
        OBJECTIF: "",
        INDICATOR_FIELD_1: "",
        INDICATOR_FIELD_2: "",
        CIBLE: "",
        ZONE: "",
        STATUT: 0,
        STATUS: 2,
        DATE_MI_PRO: Date.newDate(),
        FINAN: "",
        COUT: 0,
        IDS_AGENCY: [],
        STATUT_BUDGET: 0,
        ID_AGENCY: 0,
        CROSS_CUTTING_KPIS: 0,
        PORTFOLIO_CROSS_CUTTING_KPIS: 1,
        CUSTOM_FIELD: 0,
        MISSIONS: 0,
        RISK: 0,
        PROBLEM: 0,
        ACTIVE_SMS: 0,
        LINK: {
          U: 0,
          SF: 0,
          PG: 0,
          PL: 0,
          F: 0,
          TA: 0,
          TI: 0,
          TR: 0,
          FR: 0
        },
        PERIODIC_FOLLOW: "12",
        ME_METHOD: "0",
        START_MONTH: "1",
        GLOBAL_PLAN: 0,
        ACTIVITY_WEIGHT: 0,
        DISPLAY_DATA: 0 });
    },
    editItem: function editItem(item) {
      cov_2ferdkoho4.s[62]++;


      this.selectedItem = angular.copy(item);
      cov_2ferdkoho4.s[63]++;
      this.selectedItem.CHAMP_LIBRE = item.CHAMP_LIBRE == "1";
      cov_2ferdkoho4.s[64]++;
      this.selectedItem.LABEL_FIELD_1 = item.LABEL_FIELD_1;
      cov_2ferdkoho4.s[65]++;
      this.selectedItem.LABEL_FIELD_2 = item.LABEL_FIELD_2;
      cov_2ferdkoho4.s[66]++;
      this.selectedItem.OPTIONS_FIXES = item.OPTIONS_FIXES == "1";
      cov_2ferdkoho4.s[67]++;
      console.log("editItem", this.selectedItem);
      cov_2ferdkoho4.s[68]++;

      this.selectedItem.PAYS_PROJET = (cov_2ferdkoho4.b[23][0]++, this.contries.find(function (p) {
        cov_2ferdkoho4.f[6]++;
        cov_2ferdkoho4.s[69]++;
        return p.id == item.PAYS_PROJET;
      })) || (cov_2ferdkoho4.b[23][1]++, { id: 0 });

      cov_2ferdkoho4.s[70]++;

      $CRUDService.getAll('CategoryPersonnaliseA', { get: 'all', projectId: item.id }, function (data) {
        cov_2ferdkoho4.f[7]++;
        cov_2ferdkoho4.s[71]++;

        console.log("Structure données : ", data);
        cov_2ferdkoho4.s[72]++;
        $scope.categoryPers_A = data;
      });

      cov_2ferdkoho4.s[73]++;
      $CRUDService.getAll('CategoryPersonnaliseB', { get: 'all', projectId: item.id }, function (data) {
        cov_2ferdkoho4.f[8]++;
        cov_2ferdkoho4.s[74]++;

        $scope.categoryPers_B = data;
      });

      cov_2ferdkoho4.s[75]++;
      $uibModal.open({
        templateUrl: "app/views/portfolio/edit/description.html",
        controller: portfolioCtrl_edit,
        scope: $scope,
        size: "xs",
        backdrop: "static",
        windowClass: "animated fadeInRight left-modal"
      });
    },
    getAll: function getAll() {
      var _this = this;

      cov_2ferdkoho4.s[76]++;


      this.loading = true;
      var status = (cov_2ferdkoho4.s[77]++, ((cov_2ferdkoho4.b[24][0]++, localStorage.getItem("gobackportfolio")) || (cov_2ferdkoho4.b[24][1]++, null)) == null);
      cov_2ferdkoho4.s[78]++;

      $CRUDService.getAll(PATH, { get: "user_portfolio", id: -1 }, function (data_) {
        cov_2ferdkoho4.f[9]++;

        var data = (cov_2ferdkoho4.s[79]++, _this.buildTree(data_));cov_2ferdkoho4.s[80]++;


        _this.portfolios = data.map(function (project) {
          cov_2ferdkoho4.f[10]++;
          cov_2ferdkoho4.s[81]++;

          project.img = $deltahttp.getProjectRepository(project.id, $scope.view.currentDate);
          cov_2ferdkoho4.s[82]++;
          project.DATE_DEB_PROJET = Date.newDate(project.DATE_DEB_PROJET);
          cov_2ferdkoho4.s[83]++;
          project.DATE_FIN_PROJET = Date.newDate(project.DATE_FIN_PROJET);
          cov_2ferdkoho4.s[84]++;
          project.DATE_MI_PRO = Date.newDate(project.DATE_MI_PRO);
          cov_2ferdkoho4.s[85]++;
          return project;
        });

        var rightsPortfolio = (cov_2ferdkoho4.s[86]++, _this.portfolios.filter(function (item) {
          cov_2ferdkoho4.f[11]++;
          cov_2ferdkoho4.s[87]++;

          return item.CAN_SELECT;
        }));
        cov_2ferdkoho4.s[88]++;
        $rootScope.setfirstDisplay();
        var checkGoTo = (cov_2ferdkoho4.s[89]++, (cov_2ferdkoho4.b[25][0]++, rightsPortfolio.length == 1) && (cov_2ferdkoho4.b[25][1]++, !$rootScope.connectedUser.superAdmin) || (cov_2ferdkoho4.b[25][2]++, rightsPortfolio.length > 0) && (cov_2ferdkoho4.b[25][3]++, !$rootScope.connectedUser.multi));
        cov_2ferdkoho4.s[90]++;
        if ((cov_2ferdkoho4.b[27][0]++, checkGoTo) && (cov_2ferdkoho4.b[27][1]++, !$rootScope.connectedUser.autoRedirected)) {
          cov_2ferdkoho4.b[26][0]++;
          cov_2ferdkoho4.s[91]++;

          $rootScope.connectedUser.autoRedirected = true;
          cov_2ferdkoho4.s[92]++;
          _this.goToProject((cov_2ferdkoho4.b[28][0]++, rightsPortfolio[0]) || (cov_2ferdkoho4.b[28][1]++, { id: 0 }));
          cov_2ferdkoho4.s[93]++;
          return;
        } else {
          cov_2ferdkoho4.b[26][1]++;
        }
        cov_2ferdkoho4.s[94]++;
        _this.loading = false;
      });
    },
    parents: function parents() {
      var _this2 = this;

      cov_2ferdkoho4.s[95]++;

      $CRUDService.getAll(PATH, { get: "parents", id: (cov_2ferdkoho4.b[29][0]++, ((cov_2ferdkoho4.b[30][0]++, $stateParams) || (cov_2ferdkoho4.b[30][1]++, { id: 0 })).id) || (cov_2ferdkoho4.b[29][1]++, 0) }, function (data) {
        cov_2ferdkoho4.f[12]++;
        cov_2ferdkoho4.s[96]++;

        _this2.historic = data;
      });
    },
    saveItem: function saveItem() {},
    deleteItem: function deleteItem(validateItem) {
      cov_2ferdkoho4.s[97]++;

      SweetAlert.swal({
        title: $translate.instant("COMMON.CONFIRM"),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#c8c8c8",
        confirmButtonText: $translate.instant("COMMON.NO"),
        cancelButtonText: $translate.instant("COMMON.YES"),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_2ferdkoho4.f[13]++;
        cov_2ferdkoho4.s[98]++;

        if (isconfirm) {
          cov_2ferdkoho4.b[31][0]++;
          cov_2ferdkoho4.s[99]++;

          return;
        } else {
          cov_2ferdkoho4.b[31][1]++;
        }
        cov_2ferdkoho4.s[100]++;
        $scope.isloading = true;
        cov_2ferdkoho4.s[101]++;
        $CRUDService.delet(PATH, { action: "supp_definitif_portfolio", id: validateItem.id }, function (data) {
          cov_2ferdkoho4.f[14]++;
          cov_2ferdkoho4.s[102]++;

          if (data < 0) {
            cov_2ferdkoho4.b[32][0]++;
            cov_2ferdkoho4.s[103]++;

            SweetAlert.swal({
              title: $translate.instant("COMMON.ERROR_DELETE"),
              text: $translate.instant("PROJECT.ERROR.DELETE")
            });
            cov_2ferdkoho4.s[104]++;
            $scope.isloading = false;
            cov_2ferdkoho4.s[105]++;
            return;
          } else {
            cov_2ferdkoho4.b[32][1]++;
          }
          cov_2ferdkoho4.s[106]++;
          $scope.view.getAll();
        });
      });
    },
    openItem: function openItem(item) {
      cov_2ferdkoho4.s[107]++;

      this.historic.push(item);
      cov_2ferdkoho4.s[108]++;
      this.getAll(item.id);
    },
    goBack: function goBack() {
      cov_2ferdkoho4.s[109]++;

      this.historic.pop();
      cov_2ferdkoho4.s[110]++;
      this.getAll(this.historic.pop());
    }
  };

  var uploader = (cov_2ferdkoho4.s[111]++, $scope.uploader = new FileUploader({
    headers: $CRUDService.getHeader(),
    url: $CRUDService.getServerAdress() + "web_server.php?action=img&method=1&" + $CRUDService.getComplement() + "&li_bksb=" + PATH,
    alias: "fileformatrapp",
    removeAfterUpload: true
  }));

  cov_2ferdkoho4.s[112]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_2ferdkoho4.f[15]++;
    cov_2ferdkoho4.s[113]++;

    fileItem.url = uploader.url + "&id=" + $scope.view.selectedPortfolioImage.id;
    cov_2ferdkoho4.s[114]++;
    $scope.isloading = true;
    cov_2ferdkoho4.s[115]++;
    fileItem.upload();
  };

  cov_2ferdkoho4.s[116]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_2ferdkoho4.f[16]++;
    cov_2ferdkoho4.s[117]++;

    $scope.view.currentDate = new Date();
    cov_2ferdkoho4.s[118]++;
    for (var _iterator2 = $scope.view.portfolios, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var el = _ref2;
      cov_2ferdkoho4.s[119]++;

      if (el.id == $scope.view.selectedPortfolioImage.id) {
        cov_2ferdkoho4.b[33][0]++;
        cov_2ferdkoho4.s[120]++;

        el.img = $deltahttp.getProjectRepository(el.id, $scope.view.currentDate);
        cov_2ferdkoho4.s[121]++;
        break;
      } else {
        cov_2ferdkoho4.b[33][1]++;
      }
    }
    cov_2ferdkoho4.s[122]++;
    $scope.view.selectedPortfolioImage = null;
    cov_2ferdkoho4.s[123]++;
    $scope.isloading = false;
  };

  cov_2ferdkoho4.s[124]++;
  $scope.updateCatPersA = function (item, deleteItem) {
    cov_2ferdkoho4.f[17]++;
    cov_2ferdkoho4.s[125]++;

    $scope.categoryPers_A = (cov_2ferdkoho4.b[34][0]++, $scope.categoryPers_A) || (cov_2ferdkoho4.b[34][1]++, []);
    cov_2ferdkoho4.s[126]++;
    if (deleteItem) {
      cov_2ferdkoho4.b[35][0]++;
      cov_2ferdkoho4.s[127]++;

      $scope.categoryPers_A = $scope.categoryPers_A.filter(function (categoryPers) {
        cov_2ferdkoho4.f[18]++;
        cov_2ferdkoho4.s[128]++;

        return categoryPers.id != item.id;
      });
      cov_2ferdkoho4.s[129]++;
      return;
    } else {
      cov_2ferdkoho4.b[35][1]++;
    }
    cov_2ferdkoho4.s[130]++;
    for (var _iterator3 = $scope.categoryPers_A, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var categoryPers = _ref3;
      cov_2ferdkoho4.s[131]++;

      if (categoryPers.id == item.id) {
        cov_2ferdkoho4.b[36][0]++;
        cov_2ferdkoho4.s[132]++;

        categoryPers.NAME = item.NAME;
        cov_2ferdkoho4.s[133]++;
        categoryPers.COLOR = item.COLOR;
        cov_2ferdkoho4.s[134]++;
        return;
      } else {
        cov_2ferdkoho4.b[36][1]++;
      }
    }
    cov_2ferdkoho4.s[135]++;
    $scope.categoryPers_A.push(item);
  };

  cov_2ferdkoho4.s[136]++;
  $scope.updateCatPersB = function (item, deleteItem) {
    cov_2ferdkoho4.f[19]++;
    cov_2ferdkoho4.s[137]++;

    $scope.categoryPers_B = (cov_2ferdkoho4.b[37][0]++, $scope.categoryPers_B) || (cov_2ferdkoho4.b[37][1]++, []);
    cov_2ferdkoho4.s[138]++;
    if (deleteItem) {
      cov_2ferdkoho4.b[38][0]++;
      cov_2ferdkoho4.s[139]++;

      $scope.categoryPers_B = $scope.categoryPers_B.filter(function (categoryPers) {
        cov_2ferdkoho4.f[20]++;
        cov_2ferdkoho4.s[140]++;

        return categoryPers.id != item.id;
      });
      cov_2ferdkoho4.s[141]++;
      return;
    } else {
      cov_2ferdkoho4.b[38][1]++;
    }
    cov_2ferdkoho4.s[142]++;
    for (var _iterator4 = $scope.categoryPers_B, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var categoryPers = _ref4;
      cov_2ferdkoho4.s[143]++;

      if (categoryPers.id == item.id) {
        cov_2ferdkoho4.b[39][0]++;
        cov_2ferdkoho4.s[144]++;

        categoryPers.NAME = item.NAME;
        cov_2ferdkoho4.s[145]++;
        categoryPers.COLOR = item.COLOR;
        cov_2ferdkoho4.s[146]++;
        return;
      } else {
        cov_2ferdkoho4.b[39][1]++;
      }
    }
    cov_2ferdkoho4.s[147]++;
    $scope.categoryPers_B.push(item);
  };

  cov_2ferdkoho4.s[148]++;

  $scope.openPersonalize_1 = function () {
    cov_2ferdkoho4.f[21]++;
    cov_2ferdkoho4.s[149]++;

    $uibModal.open({
      templateUrl: 'app/views/portfolio/edit/first_customed_category.html',
      controller: Personnalize_1_Ctrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_2ferdkoho4.s[150]++;
  $scope.openPersonalize_2 = function () {
    cov_2ferdkoho4.f[22]++;
    cov_2ferdkoho4.s[151]++;

    $uibModal.open({
      templateUrl: 'app/views/portfolio/edit/second_customed_category.html',
      controller: Personnalize_2_Ctrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_2ferdkoho4.s[152]++;

  $CRUDService.getAll(PATH, { get: "portfolio_config" }, function (config) {
    cov_2ferdkoho4.f[23]++;
    cov_2ferdkoho4.s[153]++;

    if ((cov_2ferdkoho4.b[41][0]++, config) && (cov_2ferdkoho4.b[41][1]++, config.maxPortfolioDepth)) {
      cov_2ferdkoho4.b[40][0]++;
      cov_2ferdkoho4.s[154]++;

      $scope.view.maxPortfolioDepth = config.maxPortfolioDepth;
    } else {
      cov_2ferdkoho4.b[40][1]++;
    }
  });

  cov_2ferdkoho4.s[155]++;
  $scope.view.getAll();
});

function portfolioCtrl_edit($scope, $uibModalInstance, $filter, $CRUDService, $deltadate, $translate, $log) {
  cov_2ferdkoho4.f[24]++;

  var PATH = (cov_2ferdkoho4.s[156]++, "Projet");

  cov_2ferdkoho4.s[157]++;
  $scope.autoCompleteGroupOptions = null;
  cov_2ferdkoho4.s[158]++;
  $CRUDService.getAll(PATH, { get: "devises" }, function (_data) {
    cov_2ferdkoho4.f[25]++;
    cov_2ferdkoho4.s[159]++;

    $scope.autoCompleteGroupOptions = {
      minimumChars: 0,
      containerCssClass: "white-bg",
      selectedCssClass: "selected-item-auto-complete",
      noMatchTemplateEnabled: false,
      activateOnFocus: true,
      data: function data(searchText) {
        cov_2ferdkoho4.s[160]++;

        return _data;
      }
    };
  });

  cov_2ferdkoho4.s[161]++;
  $scope.dateLimit = {};

  cov_2ferdkoho4.s[162]++;
  $CRUDService.getAll(PATH, {
    get: "portfolio_limit",
    id: (cov_2ferdkoho4.b[42][0]++, $scope.view.selectedItem.id) || (cov_2ferdkoho4.b[42][1]++, 0),
    parent: $scope.view.selectedItem.ID_PARENT
  }, function (data) {
    cov_2ferdkoho4.f[26]++;
    cov_2ferdkoho4.s[163]++;

    if (data.min) {
      cov_2ferdkoho4.b[43][0]++;
      cov_2ferdkoho4.s[164]++;

      data.min.begin = Date.newDate(data.min.begin);
      cov_2ferdkoho4.s[165]++;
      data.min.end = Date.newDate(data.min.end);
      cov_2ferdkoho4.s[166]++;
      data.min.begin_str = $deltadate.format(data.min.begin, "yyyy-mm-dd");
      cov_2ferdkoho4.s[167]++;
      data.min.end_str = $deltadate.format(data.min.end, "yyyy-mm-dd");
    } else {
      cov_2ferdkoho4.b[43][1]++;
    }

    cov_2ferdkoho4.s[168]++;
    if (data.max) {
      cov_2ferdkoho4.b[44][0]++;
      cov_2ferdkoho4.s[169]++;

      data.max.begin = Date.newDate(data.max.begin);
      cov_2ferdkoho4.s[170]++;
      data.max.end = Date.newDate(data.max.end);
      cov_2ferdkoho4.s[171]++;
      data.max.begin_str = $deltadate.format(data.max.begin, "yyyy-mm-dd");
      cov_2ferdkoho4.s[172]++;
      data.max.end_str = $deltadate.format(data.max.end, "yyyy-mm-dd");
    } else {
      cov_2ferdkoho4.b[44][1]++;
    }

    cov_2ferdkoho4.s[173]++;
    $scope.dateLimit = data;
  });

  cov_2ferdkoho4.s[174]++;
  $scope.setValidData = function () {
    cov_2ferdkoho4.f[27]++;
    cov_2ferdkoho4.s[175]++;

    $scope.error = { dateLimit: [] };
    var item = (cov_2ferdkoho4.s[176]++, angular.copy($scope.view.selectedItem));

    cov_2ferdkoho4.s[177]++;
    item.CODE_PRJ = item.CODE_PRJ.toString().trim().toUpperCase();
    var items = (cov_2ferdkoho4.s[178]++, $scope.view.portfolios.filter(function (it) {
      cov_2ferdkoho4.f[28]++;
      cov_2ferdkoho4.s[179]++;

      return (cov_2ferdkoho4.b[45][0]++, it.CODE_PRJ.toUpperCase() === item.CODE_PRJ) && (cov_2ferdkoho4.b[45][1]++, it.id != item.id);
    }));

    cov_2ferdkoho4.s[180]++;
    if (items.length > 0) {
      cov_2ferdkoho4.b[46][0]++;
      cov_2ferdkoho4.s[181]++;

      $scope.error.double = true;
      cov_2ferdkoho4.s[182]++;
      return;
    } else {
      cov_2ferdkoho4.b[46][1]++;
    }

    cov_2ferdkoho4.s[183]++;

    item.DATE_DEB_PROJET = $deltadate.format(item.DATE_DEB_PROJET, "dd/mm/yyyy");
    cov_2ferdkoho4.s[184]++;
    item.DATE_FIN_PROJET = $deltadate.format(item.DATE_FIN_PROJET, "dd/mm/yyyy");
    cov_2ferdkoho4.s[185]++;
    item.DATE_MI_PRO = $deltadate.format(new Date(), "yyyy-mm-dd");
    cov_2ferdkoho4.s[186]++;
    item.PAYS_PROJET = item.PAYS_PROJET.id;
    cov_2ferdkoho4.s[187]++;
    item.CHAMP_LIBRE = $scope.view.selectedItem.CHAMP_LIBRE;
    cov_2ferdkoho4.s[188]++;
    item.LABEL_FIELD_1 = $scope.view.selectedItem.LABEL_FIELD_1;
    cov_2ferdkoho4.s[189]++;
    item.LABEL_FIELD_2 = $scope.view.selectedItem.LABEL_FIELD_2;
    cov_2ferdkoho4.s[190]++;
    item.OPTIONS_FIXES = $scope.view.selectedItem.OPTIONS_FIXES;
    cov_2ferdkoho4.s[191]++;
    $CRUDService.save(PATH, { action: "miseAJourAdmin", valeur: item }, function (value) {
      cov_2ferdkoho4.f[29]++;
      cov_2ferdkoho4.s[192]++;

      $scope.view.getAll();
      cov_2ferdkoho4.s[193]++;
      $scope.closeModal();
    });
  };
  cov_2ferdkoho4.s[194]++;
  $scope.closeModal = function () {
    cov_2ferdkoho4.f[30]++;
    cov_2ferdkoho4.s[195]++;

    $uibModalInstance.dismiss("cancel");
  };
}

function Personnalize_1_Ctrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_2ferdkoho4.f[31]++;
  cov_2ferdkoho4.s[196]++;

  $scope.addCategory = function () {
    cov_2ferdkoho4.f[32]++;
    cov_2ferdkoho4.s[197]++;

    $scope.editCategory({
      id: 0,
      NAME: ''
    });
  };

  cov_2ferdkoho4.s[198]++;
  $scope.editCategory = function (item) {
    cov_2ferdkoho4.f[33]++;
    cov_2ferdkoho4.s[199]++;

    $scope.error_code = {};
    cov_2ferdkoho4.s[200]++;
    $scope.selectedCatPersA = angular.copy(item);
  };

  cov_2ferdkoho4.s[201]++;
  $scope.cancelCategory = function () {
    cov_2ferdkoho4.f[34]++;
    cov_2ferdkoho4.s[202]++;

    $scope.selectedCatPersA = null;
  };

  cov_2ferdkoho4.s[203]++;
  $scope.validateCategory = function () {
    cov_2ferdkoho4.f[35]++;
    cov_2ferdkoho4.s[204]++;

    $scope.error_code = {};
    cov_2ferdkoho4.s[205]++;
    $scope.categoryPers_A = [];
    cov_2ferdkoho4.s[206]++;

    if ((cov_2ferdkoho4.b[48][0]++, !$scope.categoryPers_A) || (cov_2ferdkoho4.b[48][1]++, !Array.isArray($scope.categoryPers_A))) {
      cov_2ferdkoho4.b[47][0]++;
      cov_2ferdkoho4.s[207]++;

      console.warn('categoryPers_A n\'est pas un tableau valide:', $scope.categoryPers_A);
      cov_2ferdkoho4.s[208]++;

      $scope.categoryPers_A = [];
    } else {
      cov_2ferdkoho4.b[47][1]++;
    }

    cov_2ferdkoho4.s[209]++;

    if ((cov_2ferdkoho4.b[50][0]++, !$scope.selectedCatPersA) || (cov_2ferdkoho4.b[50][1]++, !$scope.selectedCatPersA.NAME)) {
      cov_2ferdkoho4.b[49][0]++;
      cov_2ferdkoho4.s[210]++;

      $scope.error_code.name = true;
      cov_2ferdkoho4.s[211]++;
      return;
    } else {
      cov_2ferdkoho4.b[49][1]++;
    }

    cov_2ferdkoho4.s[212]++;

    if ($scope.categoryPers_A.filter(function (category) {
      cov_2ferdkoho4.f[36]++;
      cov_2ferdkoho4.s[213]++;

      return (cov_2ferdkoho4.b[52][0]++, $scope.selectedCatPersA.NAME.toUpperCase() === category.NAME.toUpperCase()) && (cov_2ferdkoho4.b[52][1]++, category.id != $scope.selectedCatPersA.id);
    }).length > 0) {
      cov_2ferdkoho4.b[51][0]++;
      cov_2ferdkoho4.s[214]++;

      $scope.error_code.name = true;
      cov_2ferdkoho4.s[215]++;
      return;
    } else {
      cov_2ferdkoho4.b[51][1]++;
    }

    cov_2ferdkoho4.s[216]++;
    $CRUDService.save('CategoryPersonnaliseA', {
      action: 'MiseAJour',
      valeur: $filter('json')($scope.selectedCatPersA)
    }, function (data) {
      cov_2ferdkoho4.f[37]++;
      cov_2ferdkoho4.s[217]++;

      $scope.selectedCatPersA.id = String(parseInt(data, 10));
      cov_2ferdkoho4.s[218]++;
      $scope.updateCatPersA(angular.copy($scope.selectedCatPersA));
      cov_2ferdkoho4.s[219]++;
      $scope.selectedCatPersA = null;
    });
  };

  cov_2ferdkoho4.s[220]++;
  $scope.deleteCategory = function (item) {
    cov_2ferdkoho4.f[38]++;
    cov_2ferdkoho4.s[221]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_2ferdkoho4.f[39]++;
      cov_2ferdkoho4.s[222]++;

      if (isconfirm) {
        cov_2ferdkoho4.b[53][0]++;
        cov_2ferdkoho4.s[223]++;

        return;
      } else {
        cov_2ferdkoho4.b[53][1]++;
      }
      cov_2ferdkoho4.s[224]++;
      $scope.isloading = true;
      var validateItem = (cov_2ferdkoho4.s[225]++, {
        id: item.id
      });
      cov_2ferdkoho4.s[226]++;
      $CRUDService.delet('CategoryPersonnaliseA', { action: 'supp', id: item.id }, function (data) {
        cov_2ferdkoho4.f[40]++;
        cov_2ferdkoho4.s[227]++;

        if (data < 0) {
          cov_2ferdkoho4.b[54][0]++;
          cov_2ferdkoho4.s[228]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_2ferdkoho4.s[229]++;
          $scope.isloading = false;
          cov_2ferdkoho4.s[230]++;
          return;
        } else {
          cov_2ferdkoho4.b[54][1]++;
        }
        cov_2ferdkoho4.s[231]++;
        $scope.updateCatPersA({ id: validateItem.id }, true);
      });
    });
  };

  cov_2ferdkoho4.s[232]++;
  $scope.closeModal = function () {
    cov_2ferdkoho4.f[41]++;
    cov_2ferdkoho4.s[233]++;

    $uibModalInstance.dismiss('cancel');
  };
}

function Personnalize_2_Ctrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_2ferdkoho4.f[42]++;
  cov_2ferdkoho4.s[234]++;

  $scope.addCategory = function () {
    cov_2ferdkoho4.f[43]++;
    cov_2ferdkoho4.s[235]++;

    $scope.editCategory({
      id: 0,
      NAME: ''
    });
  };

  cov_2ferdkoho4.s[236]++;
  $scope.editCategory = function (item) {
    cov_2ferdkoho4.f[44]++;
    cov_2ferdkoho4.s[237]++;

    $scope.error_code = {};
    cov_2ferdkoho4.s[238]++;
    $scope.selectedCatPersB = angular.copy(item);
  };

  cov_2ferdkoho4.s[239]++;
  $scope.cancelCategory = function () {
    cov_2ferdkoho4.f[45]++;
    cov_2ferdkoho4.s[240]++;

    $scope.selectedCatPersB = null;
  };

  cov_2ferdkoho4.s[241]++;


  $scope.validateCategory = function () {
    cov_2ferdkoho4.f[46]++;
    cov_2ferdkoho4.s[242]++;

    $scope.error_code = {};

    cov_2ferdkoho4.s[243]++;

    if ((cov_2ferdkoho4.b[56][0]++, !$scope.categoryPers_B) || (cov_2ferdkoho4.b[56][1]++, !Array.isArray($scope.categoryPers_B))) {
      cov_2ferdkoho4.b[55][0]++;
      cov_2ferdkoho4.s[244]++;

      console.warn('categoryPers_B n\'est pas un tableau valide:', $scope.categoryPers_B);
      cov_2ferdkoho4.s[245]++;

      $scope.categoryPers_B = [];
    } else {
      cov_2ferdkoho4.b[55][1]++;
    }

    cov_2ferdkoho4.s[246]++;

    if ((cov_2ferdkoho4.b[58][0]++, !$scope.selectedCatPersB) || (cov_2ferdkoho4.b[58][1]++, !$scope.selectedCatPersB.NAME)) {
      cov_2ferdkoho4.b[57][0]++;
      cov_2ferdkoho4.s[247]++;

      $scope.error_code.name = true;
      cov_2ferdkoho4.s[248]++;
      return;
    } else {
      cov_2ferdkoho4.b[57][1]++;
    }

    cov_2ferdkoho4.s[249]++;

    if ($scope.categoryPers_B.filter(function (category) {
      cov_2ferdkoho4.f[47]++;
      cov_2ferdkoho4.s[250]++;

      return (cov_2ferdkoho4.b[60][0]++, $scope.selectedCatPersB.NAME.toUpperCase() === category.NAME.toUpperCase()) && (cov_2ferdkoho4.b[60][1]++, category.id != $scope.selectedCatPersB.id);
    }).length > 0) {
      cov_2ferdkoho4.b[59][0]++;
      cov_2ferdkoho4.s[251]++;

      $scope.error_code.name = true;
      cov_2ferdkoho4.s[252]++;
      return;
    } else {
      cov_2ferdkoho4.b[59][1]++;
    }

    cov_2ferdkoho4.s[253]++;
    $CRUDService.save('CategoryPersonnaliseB', {
      action: 'MiseAJour',
      valeur: $filter('json')($scope.selectedCatPersB)
    }, function (data) {
      cov_2ferdkoho4.f[48]++;
      cov_2ferdkoho4.s[254]++;

      $scope.selectedCatPersB.id = String(parseInt(data, 10));
      cov_2ferdkoho4.s[255]++;
      $scope.updateCatPersB(angular.copy($scope.selectedCatPersB));
      cov_2ferdkoho4.s[256]++;
      $scope.selectedCatPersB = null;
    });
  };

  cov_2ferdkoho4.s[257]++;
  $scope.deleteCategory = function (item) {
    cov_2ferdkoho4.f[49]++;
    cov_2ferdkoho4.s[258]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_2ferdkoho4.f[50]++;
      cov_2ferdkoho4.s[259]++;

      if (isconfirm) {
        cov_2ferdkoho4.b[61][0]++;
        cov_2ferdkoho4.s[260]++;

        return;
      } else {
        cov_2ferdkoho4.b[61][1]++;
      }
      cov_2ferdkoho4.s[261]++;
      $scope.isloading = true;
      var validateItem = (cov_2ferdkoho4.s[262]++, {
        id: item.id
      });
      cov_2ferdkoho4.s[263]++;
      $CRUDService.delet('CategoryPersonnaliseB', { action: 'supp', id: item.id }, function (data) {
        cov_2ferdkoho4.f[51]++;
        cov_2ferdkoho4.s[264]++;

        if (data < 0) {
          cov_2ferdkoho4.b[62][0]++;
          cov_2ferdkoho4.s[265]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_2ferdkoho4.s[266]++;
          $scope.isloading = false;
          cov_2ferdkoho4.s[267]++;
          return;
        } else {
          cov_2ferdkoho4.b[62][1]++;
        }
        cov_2ferdkoho4.s[268]++;
        $scope.updateCatPersB({ id: validateItem.id }, true);
      });
    });
  };

  cov_2ferdkoho4.s[269]++;
  $scope.closeModal = function () {
    cov_2ferdkoho4.f[52]++;
    cov_2ferdkoho4.s[270]++;

    $uibModalInstance.dismiss('cancel');
  };
}